import React, { Component } from "react";
import {
  Row,
  Col,
  ButtonGroup,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import classnames from "classnames";
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  Legend,
  Category,
  DataLabel,
  ColumnSeries,
  AccumulationChartComponent,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  AccumulationDataLabel,
  AccumulationLegend,
  StackingBarSeries,
  Tooltip,
  Chart,
} from "@syncfusion/ej2-react-charts";
import Header from "../HeaderComponent/Header";
import * as Constdata from "../../Constants/ApiConstants";
import * as message from "../../Constants/MessageConstant";
import SerraError from "../CommonComponent/Error";
import ReactGA from "react-ga4";
import SerraLoader from "../CommonComponent/Loader";
import domtoimage from "dom-to-image";
import jstz from "jstz";
import {
  apiFetch,
  getStringDate,
  priceDisplay,
} from "../../Constants/CommonConstant";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { setDataSourceRes } from "../../reducers/dataSourceResSlice";
import jsPDF from "jspdf";
import imageCompression from "browser-image-compression";
import {
  addImageToPDF,
  addPdfHeader,
  compressImage,
  fetchFont,
  filterCurrentStatus,
  getElementPdfDimensions,
  isEmptyChart,
  loadImage,
  toPng,
  toPngReduceImage,
} from "../PdfComponent/PdfFunctions";
import { setDataSourceRefreshStatus } from "../../reducers/dataSourcePayloadSlice";
import { startManualRefreshDs } from "../../reducers/datasSourceRefreshListener";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.getDashData = this.getDashData.bind(this);
    this.refreshDash = this.refreshDash.bind(this);
    this.setErrorPopupState = this.setErrorPopupState.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleFunc = this.toggleFunc.bind(this);
    this.legendRenderTop = this.legendRenderTop.bind(this);
    this.legendRenderVm = this.legendRenderVm.bind(this);
    this.legendRenderAsp = this.legendRenderAsp.bind(this);
    this.legendRenderDb = this.legendRenderDb.bind(this);
    this.legendRenderRight = this.legendRenderRight.bind(this);
    this.legendRenderParking = this.legendRenderParking.bind(this);
    this.legendRenderCleanup = this.legendRenderCleanup.bind(this);
    this.template = this.chartTemplate;
    this.toggleVmsStatusModal = this.toggleVmsStatusModal.bind(this);
    this.checkRefresh = this.checkRefresh.bind(this);
    this.isDataSourceExists = this.isDataSourceExists.bind(this);
    this.resendVerification = this.resendVerification.bind(this);
    this.processResponse = this.processResponse.bind(this);
    this.filterCurrentStatus = this.filterCurrentStatus.bind(this);

    this.state = {
      innerWidth: window.innerWidth,
      disabledDatasources: [],
      disabledNotifiedIds: new Set(),
      datasourceConfigList: [],
      dsErrorMessage: "",
      chartWidth:
        window.innerWidth < 767
          ? "100%"
          : String(parseInt(window.innerWidth / 2.3)),
      chartHeight: window.innerWidth < 767 ? "325px" : "",
      providerName: "",
      loggedInUser: "",
      resizeTimer: null,
      activeTab: "1",
      activeFuncTab: "1",
      modalLoader: false,
      errormessage: "",
      errorPopup: false,
      isFreeTrial: false,
      isErrorHeader: true,
      isRenderAnyResource: false,
      isRenderVMs: false,
      isRenderASPs: false,
      isRenderDBs: false,
      isRenderCleanup: false,
      refreshTimer: null,
      costPerfPalette: ["#C4C3C3", "#2500A1", "#7501AA", "#C100B4", "#008080"],
      functionPalette: ["#C4C3C3", "#C100B4", "#7501AA", "#2500A1", "#008080"],
      resourceTypePalette: ["#B1D4FF", "#3A93FF", "#0058C1", "#004392"],
      legendSettings: {
        visible: true,
        position: "Bottom",
        margin: { top: 5 },
        padding: 10,
        alignment: "Center",
        toggleVisibility: false,
        textStyle: {
          size: window.innerWidth < 767 ? "11px" : "14px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        width: window.innerWidth < 767 ? "100%" : "",
      },
      costPerfMarker: {
        dataLabel: {
          template: null,
          position: "Outer",
          visible: true,
          font: {
            color: "#393939",
            size: window.innerWidth < 767 ? "12px" : "16px",
            fontFamily: "Poppins, sans-serif",
            fontWeight: "500",
          },
        },
      },
      chartTitleStyle: {
        color: "#393939",
        fontWeight: "500",
        size:
          window.innerWidth >= 1530
            ? "20px"
            : window.innerWidth >= 1400
            ? "18px"
            : window.innerWidth >= 1250
            ? "16px"
            : "15px",
        fontFamily: "Poppins, sans-serif",
        whiteSpace: "normal",
      },
      costxAxis: {
        valueType: "Category",
        labelStyle: {
          size: "0px",
          fontWeight: "500",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
      },
      perfxAxis: {
        valueType: "Category",
        labelStyle: {
          size: "0px",
          fontWeight: "500",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
      },
      costyAxis: {
        title: "Monthly Cost Run Rate",
        labelFormat: "${value}",
        labelStyle: {
          size: "14px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: "14px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },

        stripLines: [
          {
            text: "Saving",
            zIndex: "Over",
            start: 100,
            size: 0,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "Start",
            horizontalAlignment: "Start",
          },
          {
            text: "Spend",
            start: 100,
            size: 2,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "End",
            horizontalAlignment: "Start",
          },
        ],
      },
      costyAxisParking: {
        title: "Monthly Cost Run Rate",
        labelFormat: "${value}",
        labelStyle: {
          size: "14px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: "14px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
        stripLines: [
          {
            text: "Saving",
            zIndex: "Over",
            start: 100,
            size: 0,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "Start",
            horizontalAlignment: "Start",
          },
          {
            text: "Spend",
            start: 100,
            size: 2,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "End",
            horizontalAlignment: "Start",
          },
        ],
      },
      costyAxisCleanup: {
        title: "Monthly Cost Run Rate",
        labelFormat: "${value}",
        labelStyle: {
          size: "14px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: "14px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
        stripLines: [
          {
            text: "Saving",
            zIndex: "Over",
            start: 100,
            size: 0,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "Start",
            horizontalAlignment: "Start",
          },
          {
            text: "Spend",
            start: 100,
            size: 2,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "End",
            horizontalAlignment: "Start",
          },
        ],
      },
      perfyAxis: {
        title: "Relative Performance",
        labelStyle: {
          size: "14px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: "14px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
        stripLines: [
          {
            text: "Decline",
            zIndex: "Over",
            start: 0,
            size: 0,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "Start",
            horizontalAlignment: "Start",
          },
          {
            text: "Improve",
            start: 100,
            size: 2,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "End",
            horizontalAlignment: "Start",
          },
        ],
      },
      costyAxisVm: {
        title: "Monthly Cost Run Rate",
        labelFormat: "${value}",
        labelStyle: {
          size: "16px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: "14px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
        stripLines: [
          {
            text: "Saving",
            zIndex: "Over",
            start: 100,
            size: 0,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "Start",
            horizontalAlignment: "Start",
          },
          {
            text: "Spend",
            start: 100,
            size: 2,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "End",
            horizontalAlignment: "Start",
          },
        ],
      },
      perfyAxisVm: {
        title: "Relative Performance",
        labelStyle: {
          size: "14px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: "14px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
        stripLines: [
          {
            text: "Decline",
            zIndex: "Over",
            start: 0,
            size: 0,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "Start",
            horizontalAlignment: "Start",
          },
          {
            text: "Improve",
            start: 100,
            size: 2,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "End",
            horizontalAlignment: "Start",
          },
        ],
      },
      costyAxisAsp: {
        title: "Monthly Cost Run Rate",
        labelFormat: "${value}",
        labelStyle: {
          size: "14px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: "14px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
        stripLines: [
          {
            text: "Saving",
            zIndex: "Over",
            start: 100,
            size: 0,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "Start",
            horizontalAlignment: "Start",
          },
          {
            text: "Spend",
            start: 100,
            size: 2,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "End",
            horizontalAlignment: "Start",
          },
        ],
      },
      perfyAxisAsp: {
        title: "Relative Performance",
        labelStyle: {
          size: "14px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: "14px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
        stripLines: [
          {
            text: "Decline",
            zIndex: "Over",
            start: 0,
            size: 0,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "Start",
            horizontalAlignment: "Start",
          },
          {
            text: "Improve",
            start: 100,
            size: 2,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "End",
            horizontalAlignment: "Start",
          },
        ],
      },
      costyAxisDb: {
        title: "Monthly Cost Run Rate",
        labelFormat: "${value}",
        labelStyle: {
          size: "14px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: "14px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
        stripLines: [
          {
            text: "Saving",
            zIndex: "Over",
            start: 100,
            size: 0,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "Start",
            horizontalAlignment: "Start",
          },
          {
            text: "Spend",
            start: 100,
            size: 2,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "End",
            horizontalAlignment: "Start",
          },
        ],
      },
      perfyAxisDb: {
        title: "Relative Performance",
        labelStyle: {
          size: "14px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: "14px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
        stripLines: [
          {
            text: "Decline",
            zIndex: "Over",
            start: 0,
            size: 0,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "Start",
            horizontalAlignment: "Start",
          },
          {
            text: "Improve",
            start: 100,
            size: 2,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "End",
            horizontalAlignment: "Start",
          },
        ],
      },
      costyAxisRight: {
        title: "Monthly Cost Run Rate",
        labelFormat: "${value}",
        labelStyle: {
          size: "14px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: "14px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
        stripLines: [
          {
            text: "Saving",
            zIndex: "Over",
            start: 100,
            size: 0,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "Start",
            horizontalAlignment: "Start",
          },
          {
            text: "Spend",
            start: 100,
            size: 2,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "End",
            horizontalAlignment: "Start",
          },
        ],
      },
      perfyAxisRight: {
        title: "Relative Performance",
        labelStyle: {
          size: "14px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: "14px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
        stripLines: [
          {
            text: "Decline",
            zIndex: "Over",
            start: 0,
            size: 0,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "Start",
            horizontalAlignment: "Start",
          },
          {
            text: "Improve",
            start: 100,
            size: 2,
            sizeType: "Pixel",
            dashArray: "10,5",
            color: "#FF9B29",
            verticalAlignment: "End",
            horizontalAlignment: "Start",
          },
        ],
      },
      datalabel: {
        visible: true,
        position: "Outside",
        connectorStyle: { length: "10px" },
        font: {
          color: "#393939",
          size: "14px",
          fontWeight: "600",
          fontFamily: "Poppins, sans-serif",
        },
      },
      pieLegendSettings: {
        position: "Bottom",
        padding: 5,
        visible: true,
        toggleVisibility: false,
        alignment: "Center",
        textStyle: {
          fontFamily: "Poppins, sans-serif",
          size: window.innerWidth < 767 ? "11px" : "14px",
        },
        width: window.innerWidth < 767 ? "100%" : "",
      },
      pieLegendSettingsAll: {
        position: "Bottom",
        padding: 5,
        visible: true,
        toggleVisibility: false,
        alignment: "Center",
        textStyle: {
          fontFamily: "Poppins, sans-serif",
          size: window.innerWidth < 767 ? "11px" : "14px",
        },
        width: window.innerWidth < 767 ? "100%" : "",
      },
      vmsStatusModal: false,
      vmsCurrentStatus: null,
      isFetchingStatus: false,
      // timerId: null,
      startRefresh: false,
      isPdfClick: false,
      dsFetching: false,
      isUserVerified: true,
      value: [],
      showFullDatasourceMessage: false,
    };
    this.timerId = null;
  }

  async componentDidMount() {
    // if (window.innerWidth < 1650 && window.innerWidth > 1400) {
    //   await this.setState({ chartWidth: "595" });
    // } else if (window.innerWidth < 1400 && window.innerWidth > 1100) {
    //   await this.setState({ chartWidth: "595" });
    // } else if (window.innerWidth < 1100) {
    //   await this.setState({ chartWidth: "400" });
    // }

    if (this.state.innerWidth !== window.innerWidth) {
      let width =
        window.innerWidth < 767
          ? "100%"
          : String(parseInt(window.innerWidth / 2.3));
      this.setState({ innerWidth: window.innerWidth, chartWidth: width });

      window.dispatchEvent(new Event("resize"));
    }

    // ReactGA.initialize(message.MeasurementId);
    // ReactGA.send({
    //   hitType: "pageview",
    //   page: window.location.pathname,
    //   title: "Dashboard",
    // });
    this.props.registerListners();
    await this.refreshDash(true, true);
    clearTimeout(this.state.resizeTimer);
  }

  setErrorPopupState = (event) => {
    this.setState({ errorPopup: event });
    if (this.state.isRedirect) {
      this.props.processLogut();
      this.props.history.push("/");
    }
  };

  getDashData(isLoader = true) {
    this.setState({ modalLoader: isLoader });
    if (isLoader) {
      this.props.registerListners(true);
    }

    apiFetch(Constdata.GET_DASHBOARD_DATA_URL, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
    })
      .then(async (responseJson) => {
        if (
          responseJson.success === true &&
          responseJson.data !== undefined &&
          responseJson.data !== null
        ) {
          this.setState({
            costPerfMarker: {
              dataLabel: {
                template: this.template(responseJson.data?.userCurrency),
                position: "Outer",
                visible: true,
                font: {
                  color: "#393939",
                  size: window.innerWidth < 767 ? "12px" : "16px",
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: "500",
                },
              },
            },
            providerName: responseJson.orgInfo.providerName,
            loggedInUser: responseJson.orgInfo.loggedInUser,
            vmsCurrentStatus: responseJson.data.currentStatus,
            isFreeTrial: responseJson.orgInfo.plan === "FREE_TRIAL",
            isUserVerified: responseJson.orgInfo.isUserVerified,
          });

          if (responseJson.orgInfo && responseJson.orgInfo.isUserVerified) {
            window.localStorage.removeItem("resendEmail");
          }

          let maxVal =
            responseJson.data.costGraph?.costGraphList.length > 0
              ? Math.max(
                  responseJson.data.costGraph?.costGraphList[0].currentPrice,
                  responseJson.data.costGraph?.costGraphList[0].selectedPrice,
                  responseJson.data.costGraph?.costGraphList[0].aggressivePrice,
                  responseJson.data.costGraph?.costGraphList[0].balancedPrice,
                  responseJson.data.costGraph?.costGraphList[0]
                    .conservativePrice
                )
              : 0;
          let interval = Math.round(maxVal / 4);
          let maxValPerf =
            responseJson.data.perfGraph?.perfDTOList.length > 0
              ? Math.max(
                  responseJson.data.perfGraph?.perfDTOList[0].resizedPerf,
                  responseJson.data.perfGraph?.perfDTOList[0].currentPerf,
                  responseJson.data.perfGraph?.perfDTOList[0].resizedPerf,
                  responseJson.data.perfGraph?.perfDTOList[0].aggressivePerf,
                  responseJson.data.perfGraph?.perfDTOList[0].balancedPerf,
                  responseJson.data.perfGraph?.perfDTOList[0].conservativePerf
                )
              : 0;
          let intervalPerf = Math.round(maxValPerf / 4);
          if (intervalPerf === 0) {
            intervalPerf = 0.25;
          }
          if (maxValPerf === 0) {
            maxValPerf = 1;
          }
          await this.setState({
            costyAxis: {
              minimum: 0,
              maximum: maxVal + interval,
              interval: interval,
            },
            perfyAxis: {
              minimum: 0,
              maximum: maxValPerf + intervalPerf,
              interval: intervalPerf,
            },
          });
          //VM

          let maxValVm =
            responseJson.data.resourceDashboardMap?.VM?.costGraph.costGraphList
              .length > 0
              ? Math.max(
                  responseJson.data.resourceDashboardMap?.VM?.costGraph
                    .costGraphList[0].currentPrice,
                  responseJson.data.resourceDashboardMap?.VM?.costGraph
                    .costGraphList[0].selectedPrice,
                  responseJson.data.resourceDashboardMap?.VM?.costGraph
                    .costGraphList[0].aggressivePrice,
                  responseJson.data.resourceDashboardMap?.VM?.costGraph
                    .costGraphList[0].balancedPrice,
                  responseJson.data.resourceDashboardMap?.VM?.costGraph
                    .costGraphList[0].conservativePrice
                )
              : 0;

          let intervalVm = Math.round(maxValVm / 4);
          let maxValPerfVm =
            responseJson.data.resourceDashboardMap?.VM?.perfGraph.perfDTOList
              .length > 0
              ? Math.max(
                  responseJson.data.resourceDashboardMap?.VM?.perfGraph
                    .perfDTOList[0].resizedPerf,
                  responseJson.data.resourceDashboardMap?.VM?.perfGraph
                    .perfDTOList[0].currentPerf,
                  responseJson.data.resourceDashboardMap?.VM?.perfGraph
                    .perfDTOList[0].aggressivePerf,
                  responseJson.data.resourceDashboardMap?.VM?.perfGraph
                    .perfDTOList[0].balancedPerf,
                  responseJson.data.resourceDashboardMap?.VM?.perfGraph
                    .perfDTOList[0].conservativePerf
                )
              : 0;
          let intervalPerfVm = Math.round(maxValPerfVm / 4);
          if (intervalPerfVm === 0) {
            intervalPerfVm = 0.25;
          }
          if (maxValPerfVm === 0) {
            maxValPerfVm = 1;
          }
          await this.setState({
            costyAxisVm: {
              ...this.state.costyAxisVm,
              minimum: 0,
              maximum: maxValVm + intervalVm,
              interval: intervalVm,
            },
            perfyAxisVm: {
              ...this.state.perfyAxisVm,
              minimum: 0,
              maximum: maxValPerfVm + intervalPerfVm,
              interval: intervalPerfVm,
            },
          });
          //ASP
          let maxValAsp =
            responseJson.data.resourceDashboardMap?.ASP?.costGraph.costGraphList
              .length > 0
              ? Math.max(
                  responseJson.data.resourceDashboardMap?.ASP?.costGraph
                    .costGraphList[0].currentPrice,
                  responseJson.data.resourceDashboardMap?.ASP?.costGraph
                    .costGraphList[0].aggressivePrice,
                  responseJson.data.resourceDashboardMap?.ASP?.costGraph
                    .costGraphList[0].selectedPrice,
                  responseJson.data.resourceDashboardMap?.ASP?.costGraph
                    .costGraphList[0].balancedPrice,
                  responseJson.data.resourceDashboardMap?.ASP?.costGraph
                    .costGraphList[0].conservativePrice
                )
              : 0;
          let intervalAsp = Math.round(maxValAsp / 4);
          let maxValPerfAsp =
            responseJson.data.resourceDashboardMap?.ASP?.perfGraph.perfDTOList
              .length > 0
              ? Math.max(
                  responseJson.data.resourceDashboardMap?.ASP?.perfGraph
                    .perfDTOList[0].aggressivePerf,
                  responseJson.data.resourceDashboardMap?.ASP?.perfGraph
                    .perfDTOList[0].currentPerf,
                  responseJson.data.resourceDashboardMap?.ASP?.perfGraph
                    .perfDTOList[0].balancedPerf,
                  responseJson.data.resourceDashboardMap?.ASP?.perfGraph
                    .perfDTOList[0].conservativePerf,
                  responseJson.data.resourceDashboardMap?.ASP?.perfGraph
                    .perfDTOList[0].resizedPerf
                )
              : 0;
          let intervalPerfAsp = Math.round(maxValPerfAsp / 4);
          if (intervalPerfAsp === 0) {
            intervalPerfAsp = 0.25;
          }
          if (maxValPerfAsp === 0) {
            maxValPerfAsp = 1;
          }
          await this.setState({
            costyAxisAsp: {
              ...this.state.costyAxisAsp,
              minimum: 0,
              maximum: maxValAsp + intervalAsp,
              interval: intervalAsp,
            },
            perfyAxisAsp: {
              ...this.state.perfyAxisAsp,
              minimum: 0,
              maximum: maxValPerfAsp + intervalPerfAsp,
              interval: intervalPerfAsp,
            },
          });
          //DB
          let maxValDb =
            responseJson.data.resourceDashboardMap?.DB?.costGraph.costGraphList
              .length > 0
              ? Math.max(
                  responseJson.data.resourceDashboardMap?.DB?.costGraph
                    .costGraphList[0].currentPrice,
                  responseJson.data.resourceDashboardMap?.DB?.costGraph
                    .costGraphList[0].selectedPrice,
                  responseJson.data.resourceDashboardMap?.DB?.costGraph
                    .costGraphList[0].aggressivePrice,
                  responseJson.data.resourceDashboardMap?.DB?.costGraph
                    .costGraphList[0].balancedPrice,
                  responseJson.data.resourceDashboardMap?.DB?.costGraph
                    .costGraphList[0].conservativePrice
                )
              : 0;
          let intervalDb = Math.round(maxValDb / 4);
          let maxValPerfDb =
            responseJson.data.resourceDashboardMap?.DB?.perfGraph.perfDTOList
              .length > 0
              ? Math.max(
                  responseJson.data.resourceDashboardMap?.DB?.perfGraph
                    .perfDTOList[0].resizedPerf,
                  responseJson.data.resourceDashboardMap?.DB?.perfGraph
                    .perfDTOList[0].currentPerf,
                  responseJson.data.resourceDashboardMap?.DB?.perfGraph
                    .perfDTOList[0].aggressivePerf,
                  responseJson.data.resourceDashboardMap?.DB?.perfGraph
                    .perfDTOList[0].balancedPerf,
                  responseJson.data.resourceDashboardMap?.DB?.perfGraph
                    .perfDTOList[0].conservativePerf
                )
              : 0;
          let intervalPerfDb = Math.round(maxValPerfDb / 4);
          if (intervalPerfDb === 0) {
            intervalPerfDb = 0.25;
          }
          if (maxValPerfDb === 0) {
            maxValPerfDb = 1;
          }
          await this.setState({
            costyAxisDb: {
              ...this.state.costyAxisDb,
              minimum: 0,
              maximum: maxValDb + intervalDb,
              interval: intervalDb,
            },
            perfyAxisDb: {
              ...this.state.perfyAxisDb,
              minimum: 0,
              maximum: maxValPerfDb + intervalPerfDb,
              interval: intervalPerfDb,
            },
          });
          //Rightsizing
          let maxValRight =
            responseJson.data.functionDashboardMap?.RIGHTSIZE?.costGraph
              .costGraphList.length > 0
              ? Math.max(
                  responseJson.data.functionDashboardMap?.RIGHTSIZE?.costGraph
                    .costGraphList[0].currentPrice,
                  responseJson.data.functionDashboardMap?.RIGHTSIZE?.costGraph
                    .costGraphList[0].selectedPrice,
                  responseJson.data.functionDashboardMap?.RIGHTSIZE?.costGraph
                    .costGraphList[0].aggressivePrice,
                  responseJson.data.functionDashboardMap?.RIGHTSIZE?.costGraph
                    .costGraphList[0].balancedPrice,
                  responseJson.data.functionDashboardMap?.RIGHTSIZE?.costGraph
                    .costGraphList[0].conservativePrice
                )
              : 0;
          let intervalRight = Math.round(maxValRight / 4);
          let maxValPerfRight =
            responseJson.data.functionDashboardMap?.RIGHTSIZE?.perfGraph
              .perfDTOList.length > 0
              ? Math.max(
                  responseJson.data.functionDashboardMap?.RIGHTSIZE?.perfGraph
                    .perfDTOList[0].resizedPerf,
                  responseJson.data.functionDashboardMap?.RIGHTSIZE?.perfGraph
                    .perfDTOList[0].currentPerf,
                  responseJson.data.functionDashboardMap?.RIGHTSIZE?.perfGraph
                    .perfDTOList[0].aggressivePerf,
                  responseJson.data.functionDashboardMap?.RIGHTSIZE?.perfGraph
                    .perfDTOList[0].balancedPerf,
                  responseJson.data.functionDashboardMap?.RIGHTSIZE?.perfGraph
                    .perfDTOList[0].conservativePerf
                )
              : 0;
          let intervalPerfRight = Math.round(maxValPerfRight / 4);
          if (intervalPerfRight === 0) {
            intervalPerfRight = 0.25;
          }
          if (maxValPerfRight === 0) {
            maxValPerfRight = 1;
          }
          await this.setState({
            costyAxisRight: {
              minimum: 0,
              maximum: maxValRight + intervalRight,
              interval: intervalRight,
            },
            perfyAxisRight: {
              minimum: 0,
              maximum: maxValPerfRight + intervalPerfRight,
              interval: intervalPerfRight,
            },
          });
          //Parking
          let maxValParking =
            responseJson.data.functionDashboardMap?.VM_PARKING?.costGraph
              .costGraphList.length > 0
              ? Math.max(
                  responseJson.data.functionDashboardMap?.VM_PARKING?.costGraph
                    .costGraphList[0].currentPrice,
                  responseJson.data.functionDashboardMap?.VM_PARKING?.costGraph
                    .costGraphList[0].aggressivePrice
                )
              : 0;
          let intervalParking = Math.round(maxValParking / 4);
          await this.setState({
            costyAxisParking: {
              minimum: 0,
              maximum: maxValParking + intervalParking,
              interval: intervalParking,
            },
          });
          //Cleanup
          let maxValCleanup =
            responseJson.data.functionDashboardMap?.CLEANUP?.costGraph
              .costGraphList.length > 0
              ? Math.max(
                  responseJson.data.functionDashboardMap?.CLEANUP?.costGraph
                    .costGraphList[0].currentPrice,
                  responseJson.data.functionDashboardMap?.CLEANUP?.costGraph
                    .costGraphList[0].aggressivePrice
                )
              : 0;
          let intervalCleanup = Math.round(maxValCleanup / 4);
          await this.setState({
            costyAxisCleanup: {
              ...this.state.costyAxisCleanup,
              minimum: 0,
              maximum: maxValCleanup + intervalCleanup,
              interval: intervalCleanup,
            },
          });
          let maxValTopPieChart = Math.max.apply(
            Math,
            responseJson.data.topPieChartList.map(function (o) {
              return o.y;
            })
          );
          let isRenderAnyResource = maxValTopPieChart === 0 ? false : true;
          // console.log("Top : " + maxValTopPieChart + " " + isRenderAnyResource);
          let maxValVmPieChart = Math.max.apply(
            Math,
            responseJson.data.resourceDashboardMap?.VM?.pieChartList.map(
              function (o) {
                return o.y;
              }
            )
          );
          let isRenderVmResource = maxValVmPieChart === 0 ? false : true;
          // console.log("VM : " + maxValVmPieChart + " " + isRenderVmResource);
          let maxValAspPieChart = Math.max.apply(
            Math,
            responseJson.data.resourceDashboardMap?.ASP?.pieChartList.map(
              function (o) {
                return o.y;
              }
            )
          );
          let isRenderAspResource = maxValAspPieChart === 0 ? false : true;
          // console.log("ASP : " + maxValAspPieChart + " " + isRenderAspResource);
          let maxValDbPieChart = Math.max.apply(
            Math,
            responseJson.data.resourceDashboardMap?.DB?.pieChartList.map(
              function (o) {
                return o.y;
              }
            )
          );
          let isRenderDbResource = maxValDbPieChart === 0 ? false : true;
          // console.log("DB : " + maxValDbPieChart + " " + isRenderDbResource);
          let maxValCleanupPieChart = Math.max.apply(
            Math,
            responseJson.data.functionDashboardMap?.CLEANUP?.pieChartList.map(
              function (o) {
                return o.y;
              }
            )
          );
          let isRenderCleanupResource =
            maxValCleanupPieChart === 0 ? false : true;
          // console.log(
          //   "Cleanup : " + maxValCleanupPieChart + " " + isRenderCleanupResource
          // );
          await this.setState({
            isRenderAnyResource: isRenderAnyResource,
            isRenderVMs: isRenderVmResource,
            isRenderASPs: isRenderAspResource,
            isRenderDBs: isRenderDbResource,
            isRenderCleanup: isRenderCleanupResource,
            value: responseJson.data,
          });

          let fiterData = [];
          let data = responseJson.data.topPieChartList || [];
          data.forEach(async (item) => {
            const value = item.x;
            const yName = value
              .replace("_resources_percent", "")
              .replace(/^/, "percent_");

            // Skip zero/null values
            if (parseFloat(item.actual_y) !== 0 && item.actual_y !== null) {
              const obj1 = {
                type: "StackingBar",

                dataSource: [
                  {
                    resourceName: "",
                    [yName]: item.actual_y,
                  },
                ],

                xName: "resourceName",
                yName: yName,
                name: item.text,
                legendShape: "Rectangle",
                fill: item.fill,

                marker: {
                  dataLabel: {
                    visible: true,
                    font: {
                      size: "16px",
                      fontFamily: "Poppins, sans-serif",
                    },
                    position: "Outer",
                  },
                },
              };

              fiterData.push(obj1);
            }
          });

          Chart.Inject(
            Chart,
            StackingBarSeries,
            Category,
            Tooltip,
            Legend,
            DataLabel
          );

          let chart = new Chart({
            //Initializing Primary X Axis
            primaryXAxis: {
              valueType: "Category",
              labelStyle: {
                size: "16px",
                fontWeight: "500",
                color: "#808080",
                fontFamily: "Poppins, sans-serif",
              },
            },
            //Initializing Primary Y Axis
            primaryYAxis: {
              minimum: 0,
              maximum: 100,
              interval: 25,
              labelStyle: {
                size: "12px",
                fontWeight: "400",
                color: "#393939",
                fontFamily: "Poppins, sans-serif",
              },
              labelFormat: "{value}%",
            },
            chartArea: {
              border: {
                width: 1,
              },
            },
            series: fiterData,
            legendSettings: this.state.pieLegendSettings,
            height: "180",
            title: "",
            titleStyle: this.state.chartTitleStyle,
            palettes: this.state.resourceTypePalette,
            pointRender: this.progressBarPointRenderer,
            axisLabelRender: this.axisLabelRender,
            marker: {
              dataLabel: {
                visible: true,
                position: "Middle",
                font: {
                  size: "16px",
                  fontFamily: "Poppins, sans-serif",
                },
              },
            },
          });
          chart.appendTo("#Chart");

          var timerId = setTimeout(() => {
            if (responseJson.orgInfo.numConfigs !== 0) {
              this.refreshActiveTabCharts();
              this.refreshActiveTabChartsVms();
              this.perfChart.refresh();
              this.costChart.refresh();
              window.dispatchEvent(new Event("resize"));
            }
          }, 1);
          await this.setState({ resizeTimer: timerId, modalLoader: false });
        } else if (responseJson.data === undefined) {
          // console.log(responseJson);
          this.setState({ modalLoader: false });
        } else if (responseJson.status === 403 || responseJson.status === 401) {
          //this.setState({ modalLoader: false, errorPopup: true, errormessage: message.SessionExpiredText, isErrorHeader: false });
          await clearInterval(this.state.refreshTimer);
        } else {
          this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.ServerError,
            isErrorHeader: false,
          });
          await clearInterval(this.state.refreshTimer);
        }
      })
      .catch((error) => {
        this.setState({
          modalLoader: false,
          errorPopup: true,
          errormessage: message.CacheErrorText,
          isErrorHeader: false,
        });
      });
  }

  activateTabAndWait = async (tabId) => {
    const tab = document.getElementById(tabId);

    if (!tab.classList.contains("active")) {
      tab.classList.add("active");
    }
    // Allow DOM + CSS to settle
    await new Promise((r) => setTimeout(r, 300));
    window.dispatchEvent(new Event("resize"));
    await new Promise((r) => setTimeout(r, 2000));
  };

  getClientSidePdf = async () => {
    let timer = null;

    try {
      let isMobileDevice = window.innerWidth < 767;

      this.setState({ modalLoader: true, isPdfClick: true });

      // Click logic
      const clickLogic = async () => {
        document.getElementById("costArrowIconStr").click();
        document.getElementById("costChartStr").click();
        document.getElementById("perfArrowIconStr").click();
        document.getElementById("overAllProgressStr").click();
        document.getElementById("perfChartStr").click();

        if (this.state.isRenderAnyResource) {
          if (this.state.isRenderVMs) {
            document.getElementById("vmCharts").click();
          }
          if (this.state.isRenderASPs) {
            document.getElementById("aspCharts").click();
          }
          if (this.state.isRenderDBs) {
            document.getElementById("dbCharts").click();
          }
          if (this.state.isRenderAnyResource) {
            document.getElementById("rightsizingCharts").click();
          }
          if (this.state.isRenderAnyResource) {
            document.getElementById("parkingCharts").click();
          }
          if (this.state.isRenderCleanup) {
            document.getElementById("cleanupCharts").click();
          }
        }
      };

      timer = setInterval(clickLogic, 5000);

      const costDims = getElementPdfDimensions("costArrowIconStr");
      const perfDims = getElementPdfDimensions("perfArrowIconStr");
      const overAllProgresDims = getElementPdfDimensions("overAllProgressStr");

      //  ==========================> Get images from chart <==========================
      const costArrowIcon = await toPngReduceImage("costArrowIconStr");
      const costArrowIconStr = await compressImage(costArrowIcon);

      const perfArrowIcon = await toPngReduceImage("perfArrowIconStr");
      const perfArrowIconStr = await compressImage(perfArrowIcon);

      // const overAllProgress = await toPngReduceImage("overAllProgressStr");
      const overAllProgress = await toPng("overAllProgressStr");

      const overAllProgressStr = await compressImage(overAllProgress);

      let costChartDims = "";
      let costChart = "";

      if (await isEmptyChart(this.state.value?.costGraph?.costGraphList)) {
        if (isMobileDevice) {
          costChartDims = getElementPdfDimensions("costChartStr");
        }
        costChart = await toPng("costChartStr");
      }
      const costChartStr = costChart ? await compressImage(costChart) : "";

      const perfChart = (await isEmptyChart(
        this.state.value.perfGraph.perfDTOList
      ))
        ? await toPng("perfChartStr")
        : "";

      const perfChartStr = perfChart ? await compressImage(perfChart) : "";

      var styleChange = false;
      var tab = "";
      var vmCharts = "";
      var vmChartsDims = "";
      if (
        this.state.isRenderVMs &&
        ((await isEmptyChart(
          this.state.value.resourceDashboardMap.VM.costGraph.costGraphList
        )) ||
          (await isEmptyChart(
            this.state.value.resourceDashboardMap.VM.perfGraph.perfDTOList
          )) ||
          (await isEmptyChart(
            this.state.value.resourceDashboardMap.VM.pieChartList
          )))
      ) {
        tab = document.getElementById("vmChartsTab");
        if (tab.className !== "tab-pane active") {
          tab.className = "tab-pane active";
          styleChange = true;
        }

        await this.activateTabAndWait("vmCharts");
        if (isMobileDevice) {
          vmChartsDims = getElementPdfDimensions("vmCharts");
        }

        let vmChartsImg = await toPng("vmCharts");
        vmCharts = await compressImage(vmChartsImg);

        if (styleChange) {
          tab.className = "tab-pane";
          styleChange = false;
        }
      }

      var aspCharts = "";
      let aspChartsDims = "";
      if (
        this.state.isRenderASPs &&
        ((await isEmptyChart(
          this.state.value.resourceDashboardMap.ASP.costGraph.costGraphList
        )) ||
          (await isEmptyChart(
            this.state.value.resourceDashboardMap.ASP.perfGraph.perfDTOList
          )) ||
          (await isEmptyChart(
            this.state.value.resourceDashboardMap.ASP.pieChartList
          )))
      ) {
        tab = document.getElementById("aspChartsTab");
        if (tab.className !== "tab-pane active") {
          tab.className = "tab-pane active";
          styleChange = true;
        }

        await this.activateTabAndWait("aspCharts");
        if (isMobileDevice) {
          aspChartsDims = getElementPdfDimensions("aspCharts");
        }

        let aspChartsImg = await toPng("aspCharts");
        aspCharts = await compressImage(aspChartsImg);

        if (styleChange) {
          tab.className = "tab-pane";
          styleChange = false;
        }
      }

      var dbCharts = "";
      let dbChartsDims = "";

      if (
        this.state.isRenderDBs &&
        ((await isEmptyChart(
          this.state.value.resourceDashboardMap.DB.costGraph.costGraphList
        )) ||
          (await isEmptyChart(
            this.state.value.resourceDashboardMap.DB.perfGraph.perfDTOList
          )) ||
          (await isEmptyChart(
            this.state.value.resourceDashboardMap.DB.pieChartList
          )))
      ) {
        tab = document.getElementById("dbChartsTab");
        if (tab.className !== "tab-pane active") {
          tab.className = "tab-pane active";
          styleChange = true;
        }

        await this.activateTabAndWait("dbCharts");

        if (isMobileDevice) {
          dbChartsDims = getElementPdfDimensions("dbCharts");
        }

        let dbChartsImg = await toPng("dbCharts");
        dbCharts = await compressImage(dbChartsImg);

        if (styleChange) {
          tab.className = "tab-pane";
          styleChange = false;
        }
      }
      var rightsizingCharts = "";
      let rightsizingChartsDims = "";
      if (
        this.state.isRenderAnyResource &&
        ((await isEmptyChart(
          this.state.value?.functionDashboardMap?.RIGHTSIZE.costGraph
            .costGraphList
        )) ||
          (await isEmptyChart(
            this.state.value?.functionDashboardMap?.RIGHTSIZE.perfGraph
              .perfDTOList
          )) ||
          (await isEmptyChart(
            this.state.value?.functionDashboardMap?.RIGHTSIZE.pieChartList
          )))
      ) {
        tab = document.getElementById("rightsizingChartsTab");
        if (tab.className !== "tab-pane active") {
          tab.className = "tab-pane active";
          styleChange = true;
        }
        await this.activateTabAndWait("rightsizingCharts");

        if (isMobileDevice) {
          rightsizingChartsDims = getElementPdfDimensions("rightsizingCharts");
        }
        let rightsizingChartsImg = await toPng("rightsizingCharts");
        rightsizingCharts = await compressImage(rightsizingChartsImg);

        if (styleChange) {
          tab.className = "tab-pane";
          styleChange = false;
        }
      }
      var parkingCharts = "";
      let parkingChartsDims = "";
      if (
        this.state.isRenderAnyResource &&
        ((await isEmptyChart(
          this.state.value?.functionDashboardMap?.VM_PARKING.costGraph
            .costGraphList
        )) ||
          (await isEmptyChart(
            this.state.value?.functionDashboardMap?.VM_PARKING.pieChartList
          )))
      ) {
        tab = document.getElementById("parkingChartsTab");
        if (tab.className !== "tab-pane active") {
          tab.className = "tab-pane active";
          styleChange = true;
        }

        await this.activateTabAndWait("parkingChartsTab");
        if (isMobileDevice) {
          parkingChartsDims = getElementPdfDimensions("parkingCharts");
        }
        let parkingChartsImg = await toPng("parkingCharts");
        parkingCharts = await compressImage(parkingChartsImg);

        if (styleChange) {
          tab.className = "tab-pane";
          styleChange = false;
        }
      }

      var cleanupCharts = "";
      let cleanupChartsDims = "";

      if (
        this.state.isRenderCleanup &&
        ((await isEmptyChart(
          this.state.value?.functionDashboardMap.CLEANUP.costGraph.costGraphList
        )) ||
          (await isEmptyChart(
            this.state.value?.functionDashboardMap.CLEANUP.pieChartList
          )))
      ) {
        tab = document.getElementById("cleanupChartsTab");
        if (tab.className !== "tab-pane active") {
          tab.className = "tab-pane active";
          styleChange = true;
        }
        await this.activateTabAndWait("cleanupChartsTab");

        if (isMobileDevice) {
          cleanupChartsDims = await getElementPdfDimensions("cleanupCharts");
        }
        let cleanupChartsImg = await toPng("cleanupCharts");
        cleanupCharts = await compressImage(cleanupChartsImg);

        if (styleChange) {
          tab.className = "tab-pane";
          styleChange = false;
        }
      }

      clearInterval(timer);

      // Generate PDF

      const doc = new jsPDF();

      // const font = await this.fetchFont('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

      //  ==========================> Start Header Logo <==========================
      const imageUrl =
        window.location.origin + "" + this.props.companyDetails.LOGO;

      // Poppins
      const regularFontUrl = require(`../../font/Poppins/Poppins-Regular.ttf`);
      const semiBoldFontUrl = require(`../../font/Poppins/Poppins-SemiBold.ttf`);
      const lightFontUrl = require(`../../font/Poppins/Poppins-Light.ttf`);
      const mediumFontUrl = require(`../../font/Poppins/Poppins-Medium.ttf`);

      const [regularFont, mediumFont, lightFont, semiBold] = await Promise.all([
        fetchFont(regularFontUrl),
        fetchFont(mediumFontUrl),
        fetchFont(lightFontUrl),
        fetchFont(semiBoldFontUrl),
      ]);

      doc.addFileToVFS("Poppins-Regular.ttf", regularFont);
      doc.addFileToVFS("Poppins-Medium.ttf", mediumFont);
      doc.addFileToVFS("Poppins-Light.ttf", lightFont);
      doc.addFileToVFS("Poppins-SemiBold.ttf", semiBold);

      // Add the fonts to jsdoc
      doc.addFont("Poppins-Regular.ttf", "Poppins", "normal");
      doc.addFont("Poppins-Medium.ttf", "Poppins", "medium");
      doc.addFont("Poppins-Light.ttf", "Poppins", "light");
      doc.addFont("Poppins-SemiBold.ttf", "Poppins", "semibold");

      const imageLogo = await loadImage(imageUrl);

      const aspectRatioLogo = imageLogo.naturalWidth / imageLogo.naturalHeight;
      let logoWidth = 16;
      let logoHeight = logoWidth / aspectRatioLogo;
      const pageWidth1 = doc.internal.pageSize.getWidth();
      const xCoordinate1 = (pageWidth1 - logoWidth) / 2;

      // Add the image Logo to the PDF
      doc.addImage(imageLogo, "PNG", xCoordinate1, 1, logoWidth, logoHeight);

      //  ==========================> End Header Logo <==========================

      //Add Header

      await addPdfHeader(
        doc,
        this.props.companyDetails.CompanyName +
          " " +
          this.props.companyDetails.ServiceName,
        this.props.companyDetails.ServiceName + " Dashboard"
      );

      //  ==========================> Start Current Status Of Data Source <==========================
      doc.setFont("Poppins", "medium");
      doc.setTextColor(57, 57, 57);
      const title = "Status as of " + getStringDate(new Date());
      const textWidth = doc.getTextWidth(title);
      // const pageWidth = doc.internal.pageSize.width;
      const pageWidth = doc.internal.pageSize.getWidth();
      const xCoordinate = (pageWidth - textWidth) / 1.7;
      const yCoordinate = 40;
      doc.setFontSize(13);
      doc.text(title, xCoordinate, yCoordinate);

      const margin = 10;
      const lineHeight = 6.5;
      let yPosition = 50;
      const bullet = String.fromCharCode(8226); // Unicode for bullet

      const pdfCurrentStatus = (this.state.vmsCurrentStatus || []).filter(
        (content) =>
          !content.startsWith("Data Source Errors") &&
          !content.startsWith("Data Source Status")
      );

      pdfCurrentStatus.forEach((content) => {
        const lines = doc.splitTextToSize(content, pageWidth - 2 * margin); // Adjust width to fit page
        lines.forEach((line, key) => {
          if (yPosition + lineHeight > doc.internal.pageSize.height - margin) {
            doc.addPage();
            yPosition = margin; // Reset yPosition
          }
          if (key === 0) {
            doc.setFont("Poppins", "medium");
            doc.setFontSize(11);
          } else {
            doc.setFont("Poppins", "normal");
            doc.setFontSize(11);
          }
          doc.text(
            `${key === 0 ? bullet : "  "} ${line.trimStart()}`,
            `${key === 0 ? margin : margin + 15}`,
            yPosition
          );
          yPosition += lineHeight;
        });
      });
      doc.addPage();

      //  ==========================> End Current Status Of Data Source <==========================

      //  ==========================> Start Convert chart to images and add to pdf <==========================

      const paddingTop = 3;
      const headerHeight = 12;
      const imageYPosition = paddingTop + headerHeight + 10;
      const scaleFactor = 1;

      const pageTotalWidth = doc.internal.pageSize.getWidth();
      const columnWidth = pageTotalWidth;
      const textMargin = 5;
      const maxTextWidth = columnWidth - 2 * textMargin;
      let maxLineHeight = 5;
      const xCenter1 = columnWidth / 2;

      const imageActualWidth = costDims.width * scaleFactor;
      const centeredX = pageTotalWidth / 2 - imageActualWidth / 2;

      await addImageToPDF(
        doc,
        costArrowIconStr,
        centeredX,
        imageYPosition + 10,
        costDims.width * scaleFactor,
        costDims.height * scaleFactor,
        false,
        "top"
      );

      doc.setFontSize(9);
      doc.setFont("Poppins", "medium");
      doc.setTextColor(57, 57, 57);

      let costText = "No Change in Cost"; // Default value

      // Ensure this.state.value is defined
      if (this.state.value !== undefined) {
        const value = this.state.value;
        const totalCost = value.totalAnalysisCost;
        const totalCostPercent = value.totalAnalysisCostPercent;

        if (totalCost < 0) {
          const costValue = priceDisplay(
            Math.abs(totalCost),
            value?.userCurrency
          );
          const percentValue = parseFloat(Math.abs(totalCostPercent)).toFixed(
            2
          );

          costText = `Up to ${costValue} (${percentValue}%) Aggregate Monthly Cost Run-Rate Spend`;
        } else if (totalCost > 0) {
          const costValue = priceDisplay(totalCost, value?.userCurrency);
          const percentValue = parseFloat(totalCostPercent).toFixed(2);

          costText = `Up to ${costValue} (${percentValue}%) Aggregate Monthly Cost Run-Rate Saving`;
        } else {
          costText = "No Change in Cost";
        }
      }

      let textStartYC =
        imageYPosition + 10 + costDims.height * scaleFactor + 10;

      const splitTextVMInfo = doc.splitTextToSize(costText, maxTextWidth);

      splitTextVMInfo.forEach((line, index) => {
        textStartYC += index * maxLineHeight;
        doc.text(line, xCenter1, textStartYC + index * maxLineHeight, {
          align: "center",
        });
      });

      const imageActualWidthPerfDims = perfDims.width * scaleFactor;
      const centeredXPerfDims =
        pageTotalWidth / 2 - imageActualWidthPerfDims / 2;

      await addImageToPDF(
        doc,
        perfArrowIconStr,
        centeredXPerfDims,
        textStartYC + 25,
        perfDims.width * scaleFactor,
        perfDims.height * scaleFactor,
        false,
        "top"
      );

      let performanceText = "No Change in Performance"; // Default value

      if (this.state.value !== undefined) {
        const value = this.state.value;
        const totalPerfPercent = value.totalAnalysisPerfPercent;

        if (totalPerfPercent < 0) {
          const percentValue = parseFloat(Math.abs(totalPerfPercent)).toFixed(
            2
          );

          performanceText = `Up to ${percentValue}% Average Performance degradation`;
        } else if (totalPerfPercent > 0) {
          const percentValue = parseFloat(totalPerfPercent).toFixed(2);

          performanceText = `Up to ${percentValue}% Average Performance Improvement`;
        } else {
          performanceText = "No Change in Performance";
        }
      }

      textStartYC += perfDims.height * scaleFactor + 35;

      const splitTextVMInfo2 = doc.splitTextToSize(
        performanceText,
        maxTextWidth
      );

      doc.setFontSize(9);
      doc.setFont("Poppins", "medium");
      doc.setTextColor(57, 57, 57);

      splitTextVMInfo2.forEach((line, index) => {
        textStartYC += index * maxLineHeight;
        doc.text(line, xCenter1, textStartYC + index * maxLineHeight, {
          align: "center",
        });
      });

      // const imageActualWidthOverAllfDims =
      //   overAllProgresDims.width * scaleFactor;

      // const centeredXOverAllDims =
      //   pageTotalWidth / 2 - imageActualWidthOverAllfDims / 2;

      // await addImageToPDF(
      //   doc,
      //   overAllProgressStr,
      //   centeredXOverAllDims,
      //   textStartYC + 15,
      //   overAllProgresDims.width * scaleFactor,
      //   overAllProgresDims.height * scaleFactor
      // );

      await addImageToPDF(
        doc,
        overAllProgressStr,
        10,
        textStartYC + 15,
        "",
        ""
      );

      let costChartLeftPosition = 19;
      if (costChartDims) {
        costChartLeftPosition =
          pageTotalWidth / 2 - (costChartDims.width * 1) / 2;
      }

      await addImageToPDF(
        doc,
        costChartStr,
        costChartLeftPosition,
        imageYPosition,
        costChartDims ? costChartDims.width * 1 : "",
        costChartDims ? costChartDims.height * 1 : "",
        true
      );
      await addImageToPDF(
        doc,
        perfChartStr,
        costChartLeftPosition,
        costChartDims ? costChartDims.height * 1 + 30 : 120,
        costChartDims ? costChartDims.width * 1 : "",
        costChartDims ? costChartDims.height * 1 : ""
      );

      let vmChartsLeftPosition = 19;
      if (vmChartsDims) {
        vmChartsLeftPosition =
          pageTotalWidth / 2 - (vmChartsDims.width * 1) / 2;
      }

      if (vmCharts)
        await addImageToPDF(
          doc,
          vmCharts,
          vmChartsLeftPosition,
          10,
          vmChartsDims ? vmChartsDims.width * 1 : "",
          vmChartsDims ? vmChartsDims.height * 1 : "",
          true
        );

      let aspChartsLeftPosition = 19;
      if (aspChartsDims) {
        aspChartsLeftPosition =
          pageTotalWidth / 2 - (aspChartsDims.width * 1) / 2;
      }

      if (aspCharts)
        await addImageToPDF(
          doc,
          aspCharts,
          aspChartsLeftPosition,
          10,
          aspChartsDims ? aspChartsDims.width * 1 : "",
          aspChartsDims ? aspChartsDims.height * 1 : "",
          true
        );

      let dbChartsLeftPosition = 19;
      if (dbChartsDims) {
        dbChartsLeftPosition =
          pageTotalWidth / 2 - (dbChartsDims.width * 1) / 2;
      }

      if (dbCharts)
        await addImageToPDF(
          doc,
          dbCharts,
          dbChartsLeftPosition,
          10,
          dbChartsDims ? dbChartsDims.width * 1 : "",
          dbChartsDims ? dbChartsDims.height * 1 : "",
          true
        );

      let rightsizingChartsLeftPosition = 19;
      if (rightsizingChartsDims) {
        rightsizingChartsLeftPosition =
          pageTotalWidth / 2 - (rightsizingChartsDims.width * 1) / 2;
      }

      if (rightsizingCharts)
        await addImageToPDF(
          doc,
          rightsizingCharts,
          rightsizingChartsLeftPosition,
          imageYPosition - 8,
          rightsizingChartsDims ? rightsizingChartsDims.width * 1 : "",
          rightsizingChartsDims ? rightsizingChartsDims.height * 1 : "",
          true,
          "RIGHTSIZING"
        );

      let parkingChartsLeftPosition = 19;
      if (parkingChartsDims) {
        parkingChartsLeftPosition =
          pageTotalWidth / 2 - (parkingChartsDims.width * 1) / 2;
      }

      if (parkingCharts)
        await addImageToPDF(
          doc,
          parkingCharts,
          parkingChartsLeftPosition,
          imageYPosition - 5,
          parkingChartsDims ? parkingChartsDims.width * 1 : "",
          parkingChartsDims ? parkingChartsDims.height * 1 : "",
          true,
          "PARKING"
        );

      let cleanupChartsLeftPosition = 19;
      if (cleanupChartsDims) {
        cleanupChartsLeftPosition =
          pageTotalWidth / 2 - (cleanupChartsDims.width * 1) / 2;
      }

      if (cleanupCharts)
        await addImageToPDF(
          doc,
          cleanupCharts,
          cleanupChartsLeftPosition,
          imageYPosition - 5,
          cleanupChartsDims ? cleanupChartsDims.width * 1 : "",
          cleanupChartsDims ? cleanupChartsDims.height * 1 : "",
          true,
          "CLEANUP"
        );
      doc.save("Dashboard.pdf");
      this.setState({ modalLoader: false, isPdfClick: false });
    } catch (error) {
      console.error("Error fetching PDF:", error);
      this.setState({
        modalLoader: false,
        errorPopup: true,
        errormessage: message.CacheErrorTextPdf,
        isErrorHeader: false,
        isRedirect: false,
        isPdfClick: false,
      });
    } finally {
      if (timer) {
        clearInterval(timer);
      }
    }
  };

  refreshDash = async (forceRefresh, fromDidMount) => {
    this.timerId = null;
    // this.setState({ timerId: null });
    if (forceRefresh) {
      await this.getDashData();
      this.fetchAllConfig();
      // if (fromDidMount) {
      //   const timer = setInterval(async () => {
      //     await this.getDashData();
      //   }, 300000);
      //   await this.setState({ refreshTimer: timer });
      // }
    }
  };

  async componentWillUnmount() {
    if (this.timerId !== null) {
      await clearTimeout(this.timerId);
      // this.setState({ timerId: null });
      this.timerId = null;
    }

    if (this.state.refreshTimer !== null) {
      await clearInterval(this.state.refreshTimer);
      this.setState({ refreshTimer: null });
    }

    if (this.state.resizeTimer !== null) {
      await clearTimeout(this.state.resizeTimer);
      this.setState({ resizeTimer: null });
    }
  }

  axisLabelRender = (args) => {
    //console.log(args);
    if (!isNaN(args.value) && !isNaN(args.axis.endLabel)) {
      args.text = "";
    }
  };

  chartTemplate(userCurrency) {
    return (args) => {
      //        if (args.point.y == 0) {
      //            args.cancel = true;
      //        } else {
      var text = "";
      var seriesText = "";
      var ret = "";
      if (args.point.x === "COST") {
        var prop = args.series.properties.yName + "Percent";
        var series = args.series.properties.dataSource[0][prop];
        args.point.y = parseFloat(args.point.y).toFixed(2);
        if (args.series.properties.yName === "currentPrice") {
          text = priceDisplay(args.point.y, userCurrency);
        } else {
          text = priceDisplay(args.point.y, userCurrency);
          // seriesText = "(" + series + "%)";
          const value = parseFloat(series);
          seriesText = `(${value > 0 ? "+" : ""}${series}%)`;
        }
        ret = (
          <div style={{ color: "#393939", textAlign: "center" }}>
            <div>{text}</div>
            <div>{seriesText}</div>
          </div>
        );
      } else if (args.point.x === "PERFORMANCE") {
        var prop = args.series.properties.yName + "Percent";
        var series = args.series.properties.dataSource[0][prop];
        if (args.series.properties.yName === "currentPerf") {
          text = parseFloat(args.point.y).toFixed(2);
        } else {
          text = parseFloat(args.point.y).toFixed(2);
          // seriesText = "(" + series + "%)";
          const value = parseFloat(series);
          seriesText = `(${value > 0 ? "+" : ""}${series}%)`;
        }
        ret = (
          <div style={{ color: "#393939", textAlign: "center" }}>
            <div>{text}</div>
            <div>{seriesText}</div>
          </div>
        );
      }
      return ret;
      //}
    };
  }

  axisPointRender = (args) => {
    if (args.point.x === "COST") {
      var prop = args.series.properties.yName + "Percent";
      var series = args.series.properties.dataSource[0][prop];
      args.point.y = parseFloat(args.point.y).toFixed(2);
      if (
        args.series.properties.yName === "currentPrice" ||
        args.series.properties.yName === "aggressivePrice" ||
        args.series.properties.yName === "balancedPrice" ||
        args.series.properties.yName === "conservativePrice"
      ) {
        let price = priceDisplay(args.point.y, this.state.value?.userCurrency);
        args.point.text = price;
      } else {
        let price = priceDisplay(args.point.y, this.state.value?.userCurrency);
        args.point.text = price + " (" + series + "%)";
      }
    } else if (args.point.x === "PERFORMANCE") {
      var prop = args.series.properties.yName + "Percent";
      var series = args.series.properties.dataSource[0][prop];
      if (
        args.series.properties.yName === "currentPerf" ||
        args.series.properties.yName === "aggressivePerf" ||
        args.series.properties.yName === "balancedPerf" ||
        args.series.properties.yName === "conservativePerf"
      ) {
        args.point.text = parseFloat(args.point.y).toFixed(2);
      } else {
        args.point.text =
          parseFloat(args.point.y).toFixed(2) + " (" + series + "%)";
      }
    }
    //}
  };

  textRender = (args) => {
    if (args.point.y === "0.0") {
      args.cancel = true;
    } else {
      var prop = args.point.x;
      var result = args.series.resultData.filter((obj) => {
        return obj.x === prop;
      });
      args.text = result[0].actual_y + "%";
    }
  };
  legendRenderTop = (args) => {
    if (this.state.value !== undefined) {
      var list = this.state.value.topPieChartList;
      var result = list.filter((obj) => {
        return obj.x === args.text;
      });
      if (result !== undefined && result.length > 0) {
        args.text = result[0].text;
      }
    }
  };
  legendRenderVm = (args) => {
    if (this.state.value !== undefined) {
      var list = this.state.value.resourceDashboardMap.VM.pieChartList;
      var result = list.filter((obj) => {
        return obj.x === args.text;
      });
      if (result !== undefined && result.length > 0) {
        args.text = result[0].text;
      }
    }
  };
  legendRenderAsp = (args) => {
    if (this.state.value !== undefined) {
      var list = this.state.value.resourceDashboardMap.ASP.pieChartList;
      var result = list.filter((obj) => {
        return obj.x === args.text;
      });
      if (result !== undefined && result.length > 0) {
        args.text = result[0].text;
      }
    }
  };
  legendRenderDb = (args) => {
    if (this.state.value !== undefined) {
      var list = this.state.value.resourceDashboardMap.DB.pieChartList;
      var result = list.filter((obj) => {
        return obj.x === args.text;
      });
      if (result !== undefined && result.length > 0) {
        args.text = result[0].text;
      }
    }
  };
  legendRenderRight = (args) => {
    if (this.state.value !== undefined) {
      var list = this.state.value?.functionDashboardMap?.RIGHTSIZE.pieChartList;
      var result = list.filter((obj) => {
        return obj.x === args.text;
      });
      if (result !== undefined && result.length > 0) {
        args.text = result[0].text;
      }
    }
  };
  legendRenderParking = (args) => {
    if (this.state.value !== undefined) {
      var list =
        this.state.value?.functionDashboardMap?.VM_PARKING.pieChartList;
      var result = list.filter((obj) => {
        return obj.x === args.text;
      });
      if (result !== undefined && result.length > 0) {
        args.text = result[0].text;
      }
    }
  };
  legendRenderCleanup = (args) => {
    if (this.state.value !== undefined) {
      var list = this.state.value?.functionDashboardMap.CLEANUP.pieChartList;
      var result = list.filter((obj) => {
        return obj.x === args.text;
      });
      if (result !== undefined && result.length > 0) {
        args.text = result[0].text;
      }
    }
  };

  async toggle(tab) {
    if (this.state.activeTab !== tab) {
      await this.setState(
        {
          activeTab: tab,
        },

        () => {
          setTimeout(() => {
            this.refreshActiveTabChartsVms(tab);
            window.dispatchEvent(new Event("resize"));
          }, 50);
          // this.refreshActiveTabChartsVms();
        }
      );

      // if (tab == 1) {
      //   if (document.getElementById("vmcost_Secondary_Element")) {
      //     document.getElementById("vmcost_Secondary_Element").style.display =
      //       "none";
      //   }
      //   if (document.getElementById("vmperf_Secondary_Element")) {
      //     document.getElementById("vmperf_Secondary_Element").style.display =
      //       "none";
      //   }
      // } else if (tab == 2) {
      //   if (document.getElementById("aspcost_Secondary_Element")) {
      //     document.getElementById("aspcost_Secondary_Element").style.display =
      //       "none";
      //   }
      //   if (document.getElementById("aspperf_Secondary_Element")) {
      //     document.getElementById("aspperf_Secondary_Element").style.display =
      //       "none";
      //   }
      // } else if (tab == 3) {
      //   if (document.getElementById("dbcost_Secondary_Element")) {
      //     document.getElementById("dbcost_Secondary_Element").style.display =
      //       "none";
      //   }
      //   if (document.getElementById("dbperf_Secondary_Element")) {
      //     document.getElementById("dbperf_Secondary_Element").style.display =
      //       "none";
      //   }
      // }
    }
  }

  async toggleFunc(tab) {
    if (this.state.activeFuncTab !== tab) {
      await this.setState(
        {
          activeFuncTab: tab,
        },
        () => {
          setTimeout(() => {
            this.refreshActiveTabCharts(tab);
            window.dispatchEvent(new Event("resize"));
          }, 50);

          // this.refreshActiveTabCharts();
        }
      );

      // window.dispatchEvent(new Event("resize"));

      // if (tab == 1) {
      //   document.getElementById("rightcost_Secondary_Element").style.display =
      //     "none";
      //   document.getElementById("rightperf_Secondary_Element").style.display =
      //     "none";
      // } else if (tab == 2) {
      //   document.getElementById("parkcost_Secondary_Element").style.display =
      //     "none";
      // } else {
      //   document.getElementById("cleanupcost_Secondary_Element").style.display =
      //     "none";
      // }
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.innerWidth !== window.innerWidth) {
      let width =
        window.innerWidth < 767
          ? "100%"
          : String(parseInt(window.innerWidth / 2.3));
      this.setState({ innerWidth: window.innerWidth, chartWidth: width });
      this.refreshActiveTabCharts();
      this.refreshActiveTabChartsVms();
      window.dispatchEvent(new Event("resize"));
    }

    if (this.props.dataSourceResponse !== prevProps.dataSourceResponse) {
      var response = prevProps.dataSourceResponse;
      if (
        response &&
        response.success === true &&
        response.testConfig !== true &&
        this.state.isFetchingStatus !== true
      ) {
        await this.refreshDash(true, true);
      }
    }

    if (this.props.dataSourcePayload !== prevProps.dataSourcePayload) {
      this.setState({
        dsFetching: this.props.dataSourcePayload.length > 0 ? true : false,
      });
    }
    if (prevProps.isRefreshDSAPI !== this.props.isRefreshDSAPI) {
      if (this.props.isRefreshDSAPI) {
        this.fetchAllConfig();
      } else {
        this.getDashData();
      }
    }

    if (
      prevProps.isRefreshing !== this.props.isRefreshing &&
      this.props.datasourceRefreshStatus === "success"
    ) {
      await this.getDashData(false);
      console.log(
        "refresh Datasource status changed:",
        this.props.datasourceRefreshStatus
      );
    }
  }

  toggleVmsStatusModal = () => {
    this.setState((prevState) => ({
      vmsStatusModal: !prevState.vmsStatusModal,
    }));
  };

  isConfigFailed = (cfg, providerName) => {
    const isAccessFailed =
      cfg.status &&
      cfg.status !== "OK" &&
      cfg.status !== "FETCHING" &&
      cfg.status !== "WARNING";
    let isPricingFailed = false;
    if (providerName === "AWS") {
      isPricingFailed = cfg.priceSource === "fail";
    } else if (providerName === "AZURE") {
      if (cfg.azureSubscriptions && cfg.azureSubscriptions.length > 0) {
        isPricingFailed = cfg.azureSubscriptions.some(
          (Sb) =>
            Sb.priceThreadStatus !== null &&
            Sb.priceThreadStatus.toLowerCase() !== "ok" &&
            Sb.priceThreadStatus.toLowerCase() !== "fetching"
        );
      }
    }
    return isAccessFailed || isPricingFailed;
  };

  // The backend now records the real failure reason in statusReason for a
  // pricing-only failure too (AzureResourcesPricingService / AWSResourcesController
  // both persist a specific message there), so prefer that. Only fall back to a
  // generic message for stale/legacy records the backend hasn't re-touched yet
  // (statusReason still literally "OK" even though pricing is actually failed).
  // Determines AWS vs Azure from the shape of cfg itself (presence of
  // azureSubscriptions vs priceSource) rather than a separately-tracked
  // providerName, so this can never disagree with what's actually on cfg.
  getFailureReason = (cfg) => {
    const isAccessFailed =
      cfg.status &&
      cfg.status !== "OK" &&
      cfg.status !== "FETCHING" &&
      cfg.status !== "WARNING";
    if (isAccessFailed) {
      return cfg.statusReason || "Unknown error";
    }
    const isPricingFailed =
      cfg.azureSubscriptions !== undefined
        ? cfg.azureSubscriptions &&
          cfg.azureSubscriptions.some(
            (Sb) =>
              Sb.priceThreadStatus !== null &&
              Sb.priceThreadStatus.toLowerCase() !== "ok" &&
              Sb.priceThreadStatus.toLowerCase() !== "fetching"
          )
        : cfg.priceSource === "fail";
    if (isPricingFailed) {
      const staleReason =
        !cfg.statusReason || cfg.statusReason.toUpperCase() === "OK";
      return staleReason ? "SKU information unavailable" : cfg.statusReason;
    }
    return cfg.statusReason || "Unknown error";
  };

  fetchAllConfig = async () => {
    apiFetch(Constdata.GETALLACCOUNT_URL, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
    })
      .then(async (responseJson) => {
        if (responseJson.success === true) {
          const prevConfigsById = new Map(
            (this.state.datasourceConfigList || []).map((c) => [c.id, c])
          );

          let value = [];
          if (responseJson.orgInfo.providerName === "AWS") {
            value = responseJson.data.awsConfigs;
          } else if (responseJson.orgInfo.providerName === "AZURE") {
            value = responseJson.data.configs;
          } else {
            value = responseJson.data?.standaloneConfigs || [];
          }

          if (
            !value.find(
              (val) =>
                val.status.toLowerCase().includes("fetching") &&
                val.refreshResourceIndex > 0
            )
          ) {
            this.props.setDataSourceRefreshStatus({
              refreshStatus: [],
              isRefreshDSAPI: false,
            });
          }

          this.setState({ datasourceConfigList: value || [] });

          const providerName = responseJson.orgInfo.providerName;

          // Reflect current datasource error state on the dashboard - recomputed
          // on every poll so the warning banner appears/disappears with reality,
          // rather than being a one-time notification.
          const disabledDatasources = (value || []).filter((cfg) =>
            this.isConfigFailed(cfg, providerName)
          );
          this.setState({ disabledDatasources });

          // Pop up an alert the moment a datasource newly fails, in addition to
          // the persistent banner - only fires once per datasource (until it
          // recovers) so the 5s poll loop doesn't re-show it every tick. On the
          // very first call after login/navigation (datasourceConfigList still
          // empty), prevCfg is undefined for everything, so any datasource
          // that's already failed at that point counts as "just disabled" too -
          // this is what makes the popup fire as soon as the dashboard loads,
          // not only on a live transition during this session.
          const justDisabled = (value || []).filter((cfg) => {
            const prevCfg = prevConfigsById.get(cfg.id);
            const wasFailed = prevCfg
              ? this.isConfigFailed(prevCfg, providerName)
              : false;
            return (
              this.isConfigFailed(cfg, providerName) &&
              !wasFailed &&
              !this.state.disabledNotifiedIds.has(cfg.id)
            );
          });
          if (justDisabled.length > 0) {
            const updatedNotifiedIds = new Set(this.state.disabledNotifiedIds);
            justDisabled.forEach((cfg) => updatedNotifiedIds.add(cfg.id));
            const detail = justDisabled
              .map((cfg) => `${cfg.accountname}: ${this.getFailureReason(cfg)}`)
              .join("<br/>");
            this.setState({
              disabledNotifiedIds: updatedNotifiedIds,
              dsErrorMessage:
                "The following data source(s) have been disabled due to an error and will be excluded from VM analysis until the issue is fixed:<br/>" +
                detail,
            });
          }
          // Clear the notified flag for anything that's healthy again, so a
          // future failure on the same datasource pops up again.
          const stillFailedIds = new Set(
            (value || [])
              .filter((cfg) => this.isConfigFailed(cfg, providerName))
              .map((cfg) => cfg.id)
          );
          if (
            [...this.state.disabledNotifiedIds].some(
              (id) => !stillFailedIds.has(id)
            )
          ) {
            const prunedIds = new Set(
              [...this.state.disabledNotifiedIds].filter((id) =>
                stillFailedIds.has(id)
              )
            );
            this.setState({ disabledNotifiedIds: prunedIds });
          }

          let isFetching = false;

          value.map(async (key) => {
            let isAnyPricFetching = false;
            if (responseJson.orgInfo.providerName === "AWS") {
              isAnyPricFetching = false;
            } else {
              if (key.azureSubscriptions.length > 0) {
                key.azureSubscriptions.map((Sb, i) => {
                  if (
                    Sb.priceThreadStatus !== null &&
                    Sb.priceThreadStatus.toLowerCase().includes("fetching")
                  ) {
                    isAnyPricFetching = true;
                  }
                });
              }
            }
            if (
              key.status.toLowerCase().includes("fetching") ||
              isAnyPricFetching
            ) {
              isFetching = true;
            }
          });

          if (isFetching) {
            this.setState({ isFetchingStatus: true });

            if (this.timerId) {
              clearTimeout(this.timerId);
            }
            this.timerId = setTimeout(() => {
              this.timerId = null;
              this.fetchAllConfig();
            }, 5000);
          } else {
            if (this.timerId) {
              clearTimeout(this.timerId);
              this.timerId = null;
            }

            this.setState({ isFetchingStatus: false });
          }
        } else if (responseJson.status === 403 || responseJson.status === 401) {
          this.setState({
            isRedirect: true,
            modalLoader: false,
            errorPopup: true,
            errormessage: message.SessionExpiredText,
            isErrorHeader: false,
          });
        } else {
          this.setState({
            isRedirect: false,
            modalLoader: false,
            errorPopup: true,
            errormessage: message.SessionExpiredText,
            isErrorHeader: false,
          });
        }
      })
      .catch((error) => {
        if (this.timerId) {
          clearTimeout(this.timerId);
          this.timerId = null;
        }
        console.error("error dashboard", error);
        this.setState({
          modalLoader: false,
          errorPopup: true,
          isRedirect: false,
          isErrorHeader: false,
        });
      });
  };

  checkRefresh = async (type) => {
    this.setState({ startRefresh: true });

    this.fetchAllConfig();

    if (type === "DisableDS" || type === "EnableDS" || type === "DeleteDS") {
      await this.refreshDash(true, true);
    }
  };

  isDataSourceExists = () => {
    if (this.state.vmsCurrentStatus !== null) {
      if (
        this.state.vmsCurrentStatus[0] &&
        this.state.vmsCurrentStatus[0].includes("None")
      ) {
        return false;
      } else {
        return true;
      }
    }
  };

  resendVerification() {
    apiFetch(
      Constdata.RESEND_ACTIVATION_LINK + "?t_id=" + this.state.loggedInUser,
      {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    )
      .then((responseJson) => {
        window.localStorage.setItem("resendEmail", true);
        this.processResponse(responseJson);
      })
      .catch((error) => {
        console.error(error);
      });
  }
  processResponse = (response) => {
    if (response.success === true) {
      this.setState({ errorPopup: true, errormessage: response.message });
    } else {
      this.setState({ errorPopup: true, errormessage: response.message });
    }
  };

  filterCurrentStatus = (str) => {
    var formattedNone = str.replace(/(\nNone)/g, "\nNone\n");
    var trimmedString = formattedNone.trimStart();
    var removeExtraNewlinesAtEnd = trimmedString.replace(/(\n\n")/g, "\n");
    var removeExtraNewlinesAfterZero = removeExtraNewlinesAtEnd.replace(
      /(0\n\n)/g,
      "0\n"
    );
    let finalText = removeExtraNewlinesAfterZero.replace(
      /\n(?!\n)/g,
      "\n     "
    );

    return finalText;
  };

  refreshActiveTabCharts = (tab = "1") => {
    switch (tab) {
      case "1": // Rightsizing
        [
          this.rightCostChart,
          this.rightperfChart,
          this.rightProgressPie,
        ].forEach((chart) => {
          if (chart && typeof chart.refresh === "function") {
            chart.refresh();
          }
        });
        break;

      case "2": // Parking
        [this.parkCostChart, this.parkProgressPie].forEach((chart) => {
          if (chart && typeof chart.refresh === "function") {
            chart.refresh();
          }
        });
        break;

      case "3": // Cleanup
        [this.cleanupCostChart, this.cleanupProgressPie].forEach((chart) => {
          if (chart && typeof chart.refresh === "function") {
            chart.refresh();
          }
        });
        break;

      default:
        break;
    }
  };

  refreshActiveTabChartsVms = (tab = "1") => {
    // const charts = [
    //   this.vmCostChart,
    //   this.vmPerfChart,
    //   this.vmProgressPie,

    //   this.aspCostChart,
    //   this.aspPerfChart,
    //   this.aspProgressPie,

    //   this.dbCostChart,
    //   this.dbPerfChart,
    //   this.dbProgressPie,
    // ];

    switch (tab) {
      case "1": // vm
        [this.vmCostChart, this.vmPerfChart, this.vmProgressPie].forEach(
          (chart) => {
            if (chart && typeof chart.refresh === "function") {
              chart.refresh();
            }
          }
        );
        break;

      case "2": // asp
        [this.aspCostChart, this.aspPerfChart, this.aspProgressPie].forEach(
          (chart) => {
            if (chart && typeof chart.refresh === "function") {
              chart.refresh();
            }
          }
        );
        break;

      case "3": // db
        [this.dbCostChart, this.dbPerfChart, this.dbProgressPie].forEach(
          (chart) => {
            if (chart && typeof chart.refresh === "function") {
              chart.refresh();
            }
          }
        );
        break;
      default:
        break;
    }

    // charts.forEach((chart) => {
    //   if (chart && chart.refresh) {
    //     chart.refresh();
    //   }
    // });
  };

  render() {
    const costIcon =
      this.state.value !== undefined &&
      this.state.value.totalAnalysisCost < 0 ? (
        <img
          id="costArrowIconStr"
          className="arrowImg"
          style={{ height: "160px", width: "160px" }}
          src={require("../../images/HighCost_02.svg")}
          alt="High Cost"
        />
      ) : this.state.value !== undefined &&
        this.state.value.totalAnalysisCost > 0 ? (
        <img
          id="costArrowIconStr"
          className="arrowImg"
          style={{ height: "160px", width: "160px" }}
          src={require("../../images/LowCost_02.svg")}
          alt="Low Cost"
        />
      ) : (
        <img
          id="costArrowIconStr"
          className="arrowImg"
          style={{ height: "160px", width: "160px" }}
          src={require("../../images/EqualCost_02.svg")}
          alt="No Change in Cost"
        />
      );
    const perfIcon =
      this.state.value !== undefined &&
      this.state.value.totalAnalysisPerfPercent < 0 ? (
        <img
          id="perfArrowIconStr"
          className="arrowImg"
          style={{ height: "160px", width: "160px" }}
          src={require("../../images/LowPerformance_02.svg")}
          alt="Low Performance"
        />
      ) : this.state.value !== undefined &&
        this.state.value.totalAnalysisPerfPercent > 0 ? (
        <img
          id="perfArrowIconStr"
          className="arrowImg"
          style={{ height: "160px", width: "160px" }}
          src={require("../../images/HighPerformance_02.svg")}
          alt="High Performance"
        />
      ) : (
        <img
          id="perfArrowIconStr"
          className="arrowImg"
          style={{ height: "160px", width: "160px" }}
          src={require("../../images/EqualPerformance_02.svg")}
          alt="No Change in Performance"
        />
      );

    const costGraphList =
      this.state.value?.resourceDashboardMap?.VM?.costGraph?.costGraphList ??
      [];

    const perfDTOList =
      this.state.value?.resourceDashboardMap?.VM?.perfGraph?.perfDTOList ?? [];

    const aspCostGraphList =
      this.state.value?.resourceDashboardMap?.ASP?.costGraph?.costGraphList ??
      [];

    const aspPerGraphList =
      this.state.value?.resourceDashboardMap?.ASP?.perfGraph?.perfDTOList ?? [];

    const dbCostGraphList =
      this.state.value?.resourceDashboardMap?.DB?.costGraph?.costGraphList ??
      [];

    const dbPerGraphList =
      this.state.value?.resourceDashboardMap?.DB?.perfGraph?.perfDTOList ?? [];

    const rightsizeCostGraphList =
      this.state.value?.functionDashboardMap?.RIGHTSIZE?.costGraph
        ?.costGraphList ?? [];

    const rightsizePerfDTOList =
      this.state.value?.functionDashboardMap?.RIGHTSIZE?.perfGraph
        ?.perfDTOList ?? [];

    const parkingCostGraphList =
      this.state.value?.functionDashboardMap?.VM_PARKING?.costGraph
        ?.costGraphList ?? [];

    const cleanupCostGraphList =
      this.state.value?.functionDashboardMap?.CLEANUP?.costGraph
        ?.costGraphList ?? [];

    // "Fix Now" opens the Manage Data Source modal, which only helps for an
    // access/credentials failure - a pricing-only failure can't be fixed by
    // editing credentials there, so show a contact-support message instead.
    const hasAccessFailure =
      this.state.disabledDatasources &&
      this.state.disabledDatasources.some(
        (cfg) =>
          cfg.status &&
          cfg.status !== "OK" &&
          cfg.status !== "FETCHING" &&
          cfg.status !== "WARNING"
      );

    return (
      <div style={{ overflow: "hidden" }}>
        <Header
          history={this.props.history}
          processLogout={this.props.processLogut}
          registerListners={this.props.registerListners}
          providerName={this.state.providerName}
          loggedInUser={this.state.loggedInUser}
          checkRefresh={this.checkRefresh}
        ></Header>

        <div
          className="container-verf container-verf-padding dashboard-container"
          role="main"
          style={{ marginTop: "50px" }}
        >
          {this.props.refreshStatus.length > 0 && (
            <div className="dashboard-overlay">
              <div className="dashboard-loader">Refreshing data...</div>
            </div>
          )}

          {this.state.isFreeTrial ? (
            <>
              <Button
                className="btnBg currentStatusBtnFreeTrial"
                onClick={this.toggleVmsStatusModal}
                style={{
                  marginTop: this.state.isFreeTrial
                    ? this.state.innerWidth < "1025"
                      ? "-50px"
                      : "-65px"
                    : "-10px",
                }}
              >
                Current Status
              </Button>

              {!this.state.isUserVerified &&
              window.localStorage.getItem("resendEmail") !== "true" ? (
                <Button
                  className="btnBg verifyEmailBtnFreeTrial"
                  onClick={() => this.resendVerification()}
                  style={{
                    marginTop: this.state.isFreeTrial
                      ? this.state.innerWidth < "1025"
                        ? "-50px"
                        : "-65px"
                      : "-10px",
                  }}
                >
                  Verify Email
                </Button>
              ) : null}
            </>
          ) : (
            <div style={{ textAlign: "right" }}>
              <Button
                className="btnBg currentStatusBtn"
                onClick={this.toggleVmsStatusModal}
                style={{
                  marginTop: this.state.isFreeTrial
                    ? this.state.innerWidth < "1025"
                      ? "-50px"
                      : "-65px"
                    : "-10px",
                }}
              >
                Current Status
              </Button>
              {!this.state.isUserVerified &&
              window.localStorage.getItem("resendEmail") !== "true" ? (
                <Button
                  className="btnBg verifyEmailBtn"
                  onClick={() => this.resendVerification()}
                  style={{
                    marginTop: this.state.isFreeTrial
                      ? this.state.innerWidth < "1025"
                        ? "-50px"
                        : "-65px"
                      : "-10px",
                  }}
                >
                  Verify Email
                </Button>
              ) : null}
            </div>
          )}

          {this.state.disabledDatasources &&
          this.state.disabledDatasources.length > 0 ? (
            <div
              role="alert"
              style={{
                backgroundColor: "#FDECEA",
                border: "1px solid #F5C2C0",
                borderRadius: "4px",
                padding: "12px 16px",
                marginBottom: "16px",
                color: "#611A15",
                fontFamily: "Poppins, sans-serif",
                fontSize: "14px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "8px",
              }}
            >
              <span>
                {this.state.disabledDatasources.length > 1 ? (
                  <strong>
                    {this.state.disabledDatasources.length} datasource
                    {this.state.disabledDatasources.length > 1 ? "s" : ""}
                  </strong>
                ) : (
                  <>
                    Datasource{" "}
                    <strong>
                      {this.state.disabledDatasources[0].accountname}
                    </strong>
                  </>
                )}{" "}
                has been disabled as an error was encountered when accessing
                it. Click
                <span
                  style={{
                    color: "#1976d2",
                    cursor: "pointer",
                    marginLeft: "5px",
                    textDecoration: "underline",
                  }}
                  onClick={() =>
                    this.setState((prevState) => ({
                      errorPopup: !prevState.errorPopup,
                      isErrorHeader: false,
                      isRedirect: false,
                      errormessage: this.state.dsErrorMessage,
                    }))
                  }
                >
                  here
                </span>{" "}
                for more details.  All VMs and resources associated with the
                datasource will not be shown until he error is resolved.
              </span>
              {hasAccessFailure ? (
                <Button
                  size="sm"
                  style={{
                    backgroundColor: "#611A15",
                    border: "none",
                    whiteSpace: "nowrap",
                  }}
                  onClick={() =>
                    window.dispatchEvent(
                      new Event("serra:openManageDataSource")
                    )
                  }
                >
                  Fix Now
                </Button>
              ) : null}
            </div>
          ) : null}

          <div
            className="pageBgWhite dashboard-content"
            style={{ borderRadius: "8px" }}
          >
            <Row className="pageBgHeader">
              <Col
                sm="12"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  id="spaceFiller"
                  style={{ marginRight: "60px" }}
                  className="d-none d-md-block"
                ></div>
                <div
                  style={{
                    color: "#ffffff",
                    fontSize: "18px",
                    fontWeight: "500",
                  }}
                >
                  {" "}
                  As of{" "}
                  {this.state.value !== undefined &&
                  this.state.value.currentDateTime !== undefined
                    ? getStringDate(this.state.value.currentDateTime)
                    : ""}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    outline="true"
                    onClick={() => {
                      this.refreshDash(true, false);
                      console.log("refresh resetRefreshTimer");
                      // this.props.startRefreshTimer();
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <svg
                      id="RefreshIcon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      viewBox="0 0 27.975 26"
                    >
                      <g
                        id="Group_1680"
                        data-name="Group 1680"
                        clipPath="url(#clip-path)"
                      >
                        <path
                          id="Path_1655"
                          data-name="Path 1655"
                          d="M25.14,14.717a.764.764,0,0,0-.9.6A11.471,11.471,0,1,1,23.594,8.6L18.075,6.137a.856.856,0,0,0-1.131.434.674.674,0,0,0,.341.889L24.1,10.5a.974.974,0,0,0,1.312-.559l2.517-6.968a.73.73,0,0,0-.437-.934.8.8,0,0,0-1.026.481L24.716,7.372a12.994,12.994,0,1,0,1.019,8.247.764.764,0,0,0-.6-.9"
                          transform="translate(0 0)"
                          fill="#ffffff"
                        />
                      </g>
                    </svg>
                  </div>
                  {this.state.isRenderAnyResource ? (
                    <div
                      outline="true"
                      onClick={this.getClientSidePdf}
                      style={{ marginLeft: "10px", cursor: "pointer" }}
                    >
                      <svg
                        id="ExportPDF"
                        xmlns="http://www.w3.org/2000/svg"
                        width="22.538"
                        height="24"
                        viewBox="0 0 22.538 24"
                      >
                        <path
                          id="Path_1540"
                          data-name="Path 1540"
                          d="M486.276,502.261a1.238,1.238,0,0,1,.346.049.661.661,0,0,1,.247.148.63.63,0,0,1,.148.226.924.924,0,0,1,.042.29.677.677,0,0,1-.784.756h-.565v-1.469Z"
                          transform="translate(-481.386 -489.062)"
                          fill="#fff"
                        />
                        <path
                          id="Path_1541"
                          data-name="Path 1541"
                          d="M495.127,503.169a2.151,2.151,0,0,1,0,1.243,1.327,1.327,0,0,1-.254.473,1.058,1.058,0,0,1-.41.29,1.369,1.369,0,0,1-.551.106H493.2V502.3h.713a1.368,1.368,0,0,1,.551.106,1.155,1.155,0,0,1,.41.3A1.239,1.239,0,0,1,495.127,503.169Z"
                          transform="translate(-484.989 -489.121)"
                          fill="#fff"
                        />
                        <path
                          id="Path_1542"
                          data-name="Path 1542"
                          d="M494.413,476.9H481.657a2.071,2.071,0,0,0-2.066,2.066l0,9.5h-1.584a.606.606,0,0,0-.61.6v5.087a.608.608,0,0,0,.61.61H479.6l0,4.068a2.071,2.071,0,0,0,2.066,2.066h16.216a2.071,2.071,0,0,0,2.066-2.066V482.422Zm.308,1.779,3.438,3.438h-2.416a1.024,1.024,0,0,1-1.023-1.023Zm4.174,20.155a1.024,1.024,0,0,1-1.023,1.023H481.657a1.024,1.024,0,0,1-1.023-1.023l-.014-4.068h15.346a.608.608,0,0,0,.61-.61v-5.087a.607.607,0,0,0-.61-.6H480.528l.106-9.5a1.024,1.024,0,0,1,1.023-1.023h12.021v3.151a2.071,2.071,0,0,0,2.066,2.066H498.9Zm-18.189-5.024v-4.449h1.574a2.572,2.572,0,0,1,.807.115,1.622,1.622,0,0,1,.556.305,1.2,1.2,0,0,1,.319.461,1.584,1.584,0,0,1,.1.577,1.735,1.735,0,0,1-.1.6,1.254,1.254,0,0,1-.332.482,1.5,1.5,0,0,1-.556.305,2.511,2.511,0,0,1-.794.115h-.543v1.485Zm3.9,0v-4.449h1.723a2.657,2.657,0,0,1,.95.17,2.287,2.287,0,0,1,.726.461,2.07,2.07,0,0,1,.468.705,2.506,2.506,0,0,1,0,1.777,2.007,2.007,0,0,1-.468.705,2.174,2.174,0,0,1-.726.461,2.518,2.518,0,0,1-.95.17Zm7.081-2.53v.8h-1.519v1.73H489.13v-4.449h2.862v.794h-1.825v1.126Z"
                          transform="translate(-477.401 -476.897)"
                          fill="#fff"
                        />
                      </svg>
                    </div>
                  ) : null}
                </div>
              </Col>
            </Row>
            <Row
              className="boxShadow"
              // id="costArrowIconStr"
              style={{
                alignItems: "center",
                paddingBottom: "30px",
                justifyContent: "center",
              }}
            >
              <Col
                // id="costArrowIconStr"
                sm={window.innerWidth < 1650 ? "3" : "4"}
                // className="pt-2 pt-md-0"
                style={{ padding: "40px" }}
              >
                <Row style={{ textAlign: "center", display: "block" }}>
                  <Col>{costIcon}</Col>
                  {this.state.value !== undefined &&
                  this.state.value.totalAnalysisCost < 0 ? (
                    <Col className="dashText">
                      Up to{" "}
                      {priceDisplay(
                        Math.abs(this.state.value.totalAnalysisCost),
                        this.state.value?.userCurrency
                      )}{" "}
                      (
                      {parseFloat(
                        Math.abs(this.state.value.totalAnalysisCostPercent)
                      ).toFixed(2)}
                      %) <div>Aggregate Monthly Cost Spend</div>
                    </Col>
                  ) : this.state.value !== undefined &&
                    this.state.value.totalAnalysisCost > 0 ? (
                    <Col className="dashText">
                      Up to{" "}
                      {priceDisplay(
                        this.state.value.totalAnalysisCost,
                        this.state.value?.userCurrency
                      )}{" "}
                      (
                      {parseFloat(
                        this.state.value.totalAnalysisCostPercent
                      ).toFixed(2)}
                      %) <div>Aggregate Monthly Cost Run-Rate Saving</div>
                    </Col>
                  ) : (
                    <Col className="dashText">No Change in Cost</Col>
                  )}
                </Row>
              </Col>

              <Col
                // id="perfArrowIconStr"
                sm={window.innerWidth < 1650 ? "3" : "4"}
                className="pt-4 pt-md-0"
              >
                <Row style={{ textAlign: "center", display: "block" }}>
                  <Col>{perfIcon}</Col>
                  {this.state.value !== undefined &&
                  this.state.value.totalAnalysisPerfPercent < 0 ? (
                    <Col className="dashText">
                      Up to{" "}
                      {parseFloat(
                        Math.abs(this.state.value.totalAnalysisPerfPercent)
                      ).toFixed(2)}
                      % <div>Average Performance degradation</div>
                    </Col>
                  ) : this.state.value !== undefined &&
                    this.state.value.totalAnalysisPerfPercent > 0 ? (
                    <Col className="dashText">
                      Up to{" "}
                      {parseFloat(
                        this.state.value.totalAnalysisPerfPercent
                      ).toFixed(2)}
                      % <div>Average Performance Improvement</div>
                    </Col>
                  ) : (
                    <Col className="dashText">No Change in Performance</Col>
                  )}
                </Row>
              </Col>

              <Row>
                <Col sm="1" />
                <Col sm="10" className="pt-2 pt-md-0">
                  {this.state.value?.topPieChartList &&
                  this.state.value?.topPieChartList.length > 0 ? (
                    <div id="overAllProgressStr">
                      <div id="Chart"></div>
                    </div>
                  ) : (
                    <div className="chart-container-dash">
                      <div className="no-vms-container">No VMs</div>
                    </div>
                  )}
                  <div className="dashText">Coverage</div>

                  {/* {this.state.value !== undefined &&
                  isEmptyChart(this.state.value?.topPieChartList) ? (
                    this.state.isRenderAnyResource ? (
                      <div id="overAllProgressStr">
                        <div id="Chart"></div>
                        <div className="dashText">Coverage</div>
                      </div>
                    ) : null
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: "500",
                        fontSize: "18px",
                        color: "rgb(33, 37, 41)",
                      }}
                    >
                      {this.state.dsFetching
                        ? "Configuration Is In Progress"
                        : "No Data Source Successfully Configured"}
                    </div>
                  )} */}
                </Col>
                <Col sm="1" />
              </Row>
            </Row>

            <Row className="boxShadow" style={{ paddingTop: "20px" }}>
              <Col xs="12" sm="6" id="costChartStr">
                {this.state.value !== undefined &&
                (isEmptyChart(this.state.value?.costGraph?.costGraphList) ||
                  !this.state.isPdfClick) ? (
                  <>
                    {/* MOBILE TITLE */}

                    {/* <div className="d-block d-md-none chart-title-mobile ">
                      Aggregate Monthly Cost Run-Rate Saving by Rightsizing Goal
                      including Parking & Cleanup
                    </div> */}

                    <div
                      style={{
                        color: "#393939",
                        fontWeight: "500",
                        fontSize:
                          window.innerWidth >= 1530
                            ? "20px"
                            : window.innerWidth >= 1400
                            ? "18px"
                            : window.innerWidth >= 1250
                            ? "16px"
                            : "15px",
                        fontFamily: "Poppins, sans-serif",
                        whiteSpace: "normal",
                        textAlign: "center",
                        minHeight: "60px",
                        alignContent: "center",
                      }}
                    >
                      Aggregate Monthly Cost Run-Rate Saving by Rightsizing Goal
                      including Parking & Cleanup
                    </div>

                    <ChartComponent
                      ref={(chart) => (this.costChart = chart)}
                      id="cost"
                      primaryXAxis={this.state.costxAxis}
                      pointRender={this.axisPointRender}
                      axisLabelRender={this.axisLabelRender}
                      primaryYAxis={this.state.costyAxis}
                      title={""}
                      titleStyle={this.state.chartTitleStyle}
                      palettes={this.state.costPerfPalette}
                      legendSettings={this.state.legendSettings}
                      width={this.state.chartWidth}
                      height={this.state.chartHeight}
                    >
                      <Inject
                        services={[ColumnSeries, Legend, DataLabel, Category]}
                      />
                      <SeriesCollectionDirective>
                        <SeriesDirective
                          dataSource={
                            this.state.value?.costGraph?.costGraphList ?? []
                          }
                          xName="type"
                          yName="currentPrice"
                          name="Current"
                          type="Column"
                          legendShape="Rectangle"
                          marker={this.state.costPerfMarker}
                          columnSpacing="0.1"
                          columnWidth="1"
                        ></SeriesDirective>
                        {this.state.value !== undefined &&
                        this.state.value.costGraph !== undefined &&
                        this.state.value.costGraph?.costGraphList.length > 0 &&
                        parseFloat(
                          this.state.value.costGraph.costGraphList[0]
                            .selectedPrice
                        ) > 0 ? (
                          <SeriesDirective
                            dataSource={
                              this.state.value.costGraph.costGraphList
                            }
                            xName="type"
                            yName="selectedPrice"
                            name="Lowest"
                            type="Column"
                            legendShape="Rectangle"
                            marker={this.state.costPerfMarker}
                            columnSpacing="0.1"
                            columnWidth="1"
                          ></SeriesDirective>
                        ) : null}
                        <SeriesDirective
                          dataSource={
                            this.state.value?.costGraph?.costGraphList ?? []
                          }
                          xName="type"
                          yName="aggressivePrice"
                          name="Economical"
                          type="Column"
                          legendShape="Rectangle"
                          marker={this.state.costPerfMarker}
                          columnSpacing="0.1"
                          columnWidth="1"
                        ></SeriesDirective>
                        <SeriesDirective
                          dataSource={
                            this.state.value?.costGraph?.costGraphList ?? []
                          }
                          xName="type"
                          yName="balancedPrice"
                          name="Balanced"
                          type="Column"
                          legendShape="Rectangle"
                          marker={this.state.costPerfMarker}
                          columnSpacing="0.1"
                          columnWidth="1"
                        ></SeriesDirective>
                        <SeriesDirective
                          dataSource={
                            this.state.value?.costGraph?.costGraphList ?? []
                          }
                          xName="type"
                          yName="conservativePrice"
                          name="Enhanced"
                          type="Column"
                          legendShape="Rectangle"
                          marker={this.state.costPerfMarker}
                          columnSpacing="0.1"
                          columnWidth="1"
                        ></SeriesDirective>
                      </SeriesCollectionDirective>
                    </ChartComponent>
                  </>
                ) : null}
              </Col>
              <Col xs="12" sm="6" id="perfChartStr">
                {this.state.value !== undefined &&
                (isEmptyChart(this.state.value?.perfGraph?.perfDTOList) ||
                  !this.state.isPdfClick) ? (
                  <>
                    {/* MOBILE TITLE */}
                    {/* <div className="d-block d-md-none chart-title-mobile ">
                      Average Relative Performance by Rightsizing Goal
                    </div> */}

                    <div
                      style={{
                        color: "#393939",
                        fontWeight: "500",
                        fontSize:
                          window.innerWidth >= 1530
                            ? "20px"
                            : window.innerWidth >= 1400
                            ? "18px"
                            : window.innerWidth >= 1250
                            ? "16px"
                            : "15px",
                        fontFamily: "Poppins, sans-serif",
                        whiteSpace: "normal",
                        textAlign: "center",
                        minHeight: "60px",
                        alignContent: "center",
                      }}
                    >
                      Average Relative Performance by Rightsizing Goal
                    </div>

                    <ChartComponent
                      ref={(chart) => (this.perfChart = chart)}
                      id="perf"
                      primaryXAxis={this.state.perfxAxis}
                      pointRender={this.axisPointRender}
                      axisLabelRender={this.axisLabelRender}
                      primaryYAxis={this.state.perfyAxis}
                      title=""
                      titleStyle={this.state.chartTitleStyle}
                      palettes={this.state.costPerfPalette}
                      legendSettings={this.state.legendSettings}
                      width={this.state.chartWidth}
                      height={this.state.chartHeight}
                    >
                      <Inject
                        services={[ColumnSeries, Legend, DataLabel, Category]}
                      />
                      <SeriesCollectionDirective>
                        <SeriesDirective
                          dataSource={
                            this.state.value !== undefined &&
                            this.state.value.perfGraph !== undefined &&
                            this.state.value.perfGraph?.perfDTOList !==
                              undefined &&
                            this.state.value.perfGraph.perfDTOList.length > 0
                              ? this.state.value.perfGraph.perfDTOList
                              : []
                          }
                          xName="type"
                          yName="currentPerf"
                          name="Current"
                          type="Column"
                          legendShape="Rectangle"
                          marker={this.state.costPerfMarker}
                          columnSpacing="0.1"
                          columnWidth="1"
                        ></SeriesDirective>
                        {this.state.value !== undefined &&
                        this.state.value.perfGraph !== undefined &&
                        this.state.value.perfGraph?.perfDTOList !== undefined &&
                        this.state.value.perfGraph.perfDTOList.length > 0 &&
                        parseFloat(
                          this.state.value.perfGraph.perfDTOList[0].resizedPerf
                        ) > 0 ? (
                          <SeriesDirective
                            dataSource={
                              this.state.value !== undefined &&
                              this.state.value.perfGraph !== undefined
                                ? this.state.value.perfGraph.perfDTOList
                                : []
                            }
                            xName="type"
                            yName="resizedPerf"
                            name="Best"
                            type="Column"
                            legendShape="Rectangle"
                            marker={this.state.costPerfMarker}
                            columnSpacing="0.1"
                            columnWidth="1"
                          ></SeriesDirective>
                        ) : null}
                        <SeriesDirective
                          dataSource={
                            this.state.value !== undefined &&
                            this.state.value.perfGraph !== undefined &&
                            this.state.value.perfGraph?.perfDTOList !==
                              undefined
                              ? this.state.value.perfGraph.perfDTOList
                              : []
                          }
                          xName="type"
                          yName="aggressivePerf"
                          name="Economical"
                          type="Column"
                          legendShape="Rectangle"
                          marker={this.state.costPerfMarker}
                          columnSpacing="0.1"
                          columnWidth="1"
                        ></SeriesDirective>
                        <SeriesDirective
                          dataSource={
                            this.state.value !== undefined &&
                            this.state.value.perfGraph !== undefined &&
                            this.state.value.perfGraph?.perfDTOList !==
                              undefined
                              ? this.state.value.perfGraph.perfDTOList
                              : []
                          }
                          xName="type"
                          yName="balancedPerf"
                          name="Balanced"
                          type="Column"
                          legendShape="Rectangle"
                          marker={this.state.costPerfMarker}
                          columnSpacing="0.1"
                          columnWidth="1"
                        ></SeriesDirective>
                        <SeriesDirective
                          dataSource={
                            this.state.value !== undefined &&
                            this.state.value.perfGraph !== undefined &&
                            this.state.value.perfGraph?.perfDTOList !==
                              undefined
                              ? this.state.value.perfGraph.perfDTOList
                              : []
                          }
                          xName="type"
                          yName="conservativePerf"
                          name="Enhanced"
                          type="Column"
                          legendShape="Rectangle"
                          marker={this.state.costPerfMarker}
                          columnSpacing="0.1"
                          columnWidth="1"
                        ></SeriesDirective>
                      </SeriesCollectionDirective>
                    </ChartComponent>
                  </>
                ) : null}
              </Col>
            </Row>
            <Row
              className="boxShadow"
              id="tabRow"
              style={{
                paddingTop: "20px",
                display: this.state.isRenderAnyResource ? "flex" : "none",
              }}
            >
              <Col
                sm="6"
                style={{
                  paddingRight: window.innerWidth < 767 ? 0 : "15px",
                  paddingLeft: window.innerWidth < 767 ? 0 : "15px",
                }}
              >
                <Nav tabs className="navClass" id="dashtabs">
                  {this.state.isRenderVMs ? (
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === "1",
                        })}
                        onClick={() => {
                          this.toggle("1");
                        }}
                      >
                        VMs
                      </NavLink>
                    </NavItem>
                  ) : (
                    ""
                  )}
                  {this.state.isRenderASPs &&
                  this.state.providerName === "AZURE" ? (
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === "2",
                        })}
                        onClick={() => {
                          this.toggle("2");
                        }}
                      >
                        ASPs
                      </NavLink>
                    </NavItem>
                  ) : (
                    ""
                  )}
                  {this.state.isRenderDBs &&
                  this.state.providerName === "AZURE" ? (
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === "3",
                        })}
                        onClick={() => {
                          this.toggle("3");
                        }}
                      >
                        DBaaS
                      </NavLink>
                    </NavItem>
                  ) : (
                    ""
                  )}
                </Nav>
                <TabContent
                  id="dashtabcontent"
                  activeTab={this.state.activeTab}
                >
                  {this.state.isRenderVMs ? (
                    <TabPane tabId="1" id="vmChartsTab">
                      <Row
                        className="rmpaddingChart"
                        style={{ textAlign: "center" }}
                        id="vmCharts"
                      >
                        <Col sm="12" className="rmpaddingChart">
                          {this.state.value !== undefined &&
                          (isEmptyChart(
                            this.state.value?.resourceDashboardMap?.VM
                              ?.costGraph?.costGraphList
                          ) ||
                            !this.state.isPdfClick) ? (
                            <>
                              {" "}
                              {/* MOBILE TITLE */}
                              {/* <div className="d-block d-md-none chart-title-mobile ">
                                Aggregate VM Monthly Cost Run-Rate Saving By
                                Rightsizing and Parking
                              </div> */}
                              <div
                                style={{
                                  color: "#393939",
                                  fontWeight: "500",
                                  fontSize:
                                    window.innerWidth >= 1530
                                      ? "20px"
                                      : window.innerWidth >= 1400
                                      ? "18px"
                                      : window.innerWidth >= 1250
                                      ? "16px"
                                      : "15px",
                                  fontFamily: "Poppins, sans-serif",
                                  whiteSpace: "normal",
                                  textAlign: "center",
                                  minHeight: "60px",
                                  alignContent: "center",
                                }}
                              >
                                Aggregate VM Monthly Cost Run-Rate Saving By
                                Rightsizing and Parking
                              </div>
                              <ChartComponent
                                ref={(chart) => (this.vmCostChart = chart)}
                                id="vmcost"
                                primaryXAxis={this.state.costxAxis}
                                pointRender={this.axisPointRender}
                                axisLabelRender={this.axisLabelRender}
                                primaryYAxis={this.state.costyAxisVm}
                                title=""
                                titleStyle={this.state.chartTitleStyle}
                                palettes={this.state.costPerfPalette}
                                legendSettings={this.state.legendSettings}
                                width={this.state.chartWidth}
                                height={this.state.chartHeight}
                              >
                                <Inject
                                  services={[
                                    ColumnSeries,
                                    Legend,
                                    DataLabel,
                                    Category,
                                  ]}
                                />
                                <SeriesCollectionDirective>
                                  <SeriesDirective
                                    dataSource={costGraphList}
                                    xName="type"
                                    yName="currentPrice"
                                    name="Current"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                    animation={{
                                      enable: true,
                                      duration: 1200,
                                      delay: 100,
                                    }}
                                  ></SeriesDirective>
                                  {/* {this.state.value.resourceDashboardMap.VM
                                    .costGraph.costGraphList.length > 0 &&
                                  parseFloat(
                                    this.state.value.resourceDashboardMap.VM
                                      .costGraph.costGraphList[0].selectedPrice
                                  ) > 0 ? (
                                    <SeriesDirective
                                      dataSource={
                                        this.state.value.resourceDashboardMap.VM
                                          .costGraph.costGraphList
                                      }
                                      xName="type"
                                      yName="selectedPrice"
                                      name="Optimally Sized/Parked"
                                      type="Column"
                                      legendShape="Rectangle"
                                      marker={this.state.costPerfMarker}
                                      columnSpacing="0.1"
                                      columnWidth="1"
                                    ></SeriesDirective>
                                  ) : null} */}
                                  <SeriesDirective
                                    dataSource={costGraphList}
                                    xName="type"
                                    yName="aggressivePrice"
                                    name="Economical"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  <SeriesDirective
                                    dataSource={costGraphList}
                                    xName="type"
                                    yName="balancedPrice"
                                    name="Balanced"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  <SeriesDirective
                                    dataSource={costGraphList}
                                    xName="type"
                                    yName="conservativePrice"
                                    name="Enhanced"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                </SeriesCollectionDirective>
                              </ChartComponent>
                            </>
                          ) : null}
                        </Col>
                        <Col
                          sm="12"
                          className="rmpaddingChart"
                          style={{ marginTop: "20px" }}
                        >
                          {this.state.value !== undefined &&
                          (isEmptyChart(
                            this.state.value?.resourceDashboardMap?.VM
                              ?.perfGraph?.perfDTOList
                          ) ||
                            !this.state.isPdfClick) ? (
                            <>
                              {" "}
                              <div
                                style={{
                                  color: "#393939",
                                  fontWeight: "500",
                                  fontSize:
                                    window.innerWidth >= 1530
                                      ? "20px"
                                      : window.innerWidth >= 1400
                                      ? "18px"
                                      : window.innerWidth >= 1250
                                      ? "16px"
                                      : "15px",
                                  fontFamily: "Poppins, sans-serif",
                                  whiteSpace: "normal",
                                  textAlign: "center",
                                  minHeight: "60px",
                                  alignContent: "center",
                                }}
                              >
                                Average VM Relative Performance By Rightsizing
                              </div>
                              <ChartComponent
                                ref={(chart) => (this.vmPerfChart = chart)}
                                id="vmperf"
                                primaryXAxis={this.state.perfxAxis}
                                pointRender={this.axisPointRender}
                                axisLabelRender={this.axisLabelRender}
                                primaryYAxis={this.state.perfyAxisVm}
                                title=""
                                titleStyle={this.state.chartTitleStyle}
                                palettes={this.state.costPerfPalette}
                                legendSettings={this.state.legendSettings}
                                width={this.state.chartWidth}
                                height={this.state.chartHeight}
                              >
                                <Inject
                                  services={[
                                    ColumnSeries,
                                    Legend,
                                    DataLabel,
                                    Category,
                                  ]}
                                />
                                <SeriesCollectionDirective>
                                  <SeriesDirective
                                    dataSource={perfDTOList}
                                    xName="type"
                                    yName="currentPerf"
                                    name="Current"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  {this.state.value?.resourceDashboardMap?.VM
                                    ?.perfGraph?.perfDTOList.length > 0 &&
                                  parseFloat(
                                    this.state.value?.resourceDashboardMap?.VM
                                      ?.perfGraph?.perfDTOList[0].resizedPerf
                                  ) > 0 ? (
                                    <SeriesDirective
                                      dataSource={perfDTOList}
                                      xName="type"
                                      yName="resizedPerf"
                                      name="Optimally Sized"
                                      type="Column"
                                      legendShape="Rectangle"
                                      marker={this.state.costPerfMarker}
                                      columnSpacing="0.1"
                                      columnWidth="1"
                                    ></SeriesDirective>
                                  ) : null}
                                  <SeriesDirective
                                    dataSource={perfDTOList}
                                    xName="type"
                                    yName="aggressivePerf"
                                    name="Economical"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  <SeriesDirective
                                    dataSource={perfDTOList}
                                    xName="type"
                                    yName="balancedPerf"
                                    name="Balanced"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  <SeriesDirective
                                    dataSource={perfDTOList}
                                    xName="type"
                                    yName="conservativePerf"
                                    name="Enhanced"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                </SeriesCollectionDirective>
                              </ChartComponent>
                            </>
                          ) : null}
                        </Col>
                        <Col
                          sm="12"
                          className="rmpaddingChart"
                          style={{ textAlign: "center", marginTop: "20px" }}
                        >
                          {this.state.value !== undefined &&
                          (isEmptyChart(
                            this.state.value?.resourceDashboardMap?.VM
                              ?.pieChartList
                          ) ||
                            !this.state.isPdfClick) ? (
                            this.state.value?.resourceDashboardMap?.VM
                              ?.pieChartList &&
                            this.state.value?.resourceDashboardMap?.VM
                              ?.pieChartList.length > 0 ? (
                              <>
                                <div className="d-block d-md-none chart-title-mobile ">
                                  Progress
                                </div>
                                <AccumulationChartComponent
                                  ref={(chart) => (this.vmProgressPie = chart)}
                                  id="vmProgressPie"
                                  title="Progress"
                                  height="350"
                                  titleStyle={this.state.chartTitleStyle}
                                  textRender={this.textRender}
                                  legendSettings={
                                    this.state.pieLegendSettingsAll
                                  }
                                  legendRender={this.legendRenderVm}
                                >
                                  <Inject
                                    services={[
                                      AccumulationDataLabel,
                                      AccumulationLegend,
                                    ]}
                                  />
                                  <AccumulationSeriesCollectionDirective>
                                    <AccumulationSeriesDirective
                                      dataSource={
                                        this.state.value !== undefined
                                          ? this.state.value
                                              .resourceDashboardMap.VM
                                              .pieChartList
                                          : []
                                      }
                                      xName="x"
                                      yName="y"
                                      pointColorMapping="fill"
                                      dataLabel={this.state.datalabel}
                                      legendShape="Rectangle"
                                    ></AccumulationSeriesDirective>
                                  </AccumulationSeriesCollectionDirective>
                                </AccumulationChartComponent>
                              </>
                            ) : (
                              <div className="dashboardPieChartEmpty">
                                <div className="emptyDivChartTitle">
                                  Progress
                                </div>
                                <h6>No VMs Qualify For Rightsizing Analysis</h6>
                              </div>
                            )
                          ) : null}
                        </Col>
                      </Row>
                    </TabPane>
                  ) : null}
                  {this.state.isRenderASPs ? (
                    <TabPane tabId="2" id="aspChartsTab">
                      <Row
                        className="rmpaddingChart"
                        style={{ textAlign: "center" }}
                        id="aspCharts"
                      >
                        <Col sm="12" className="rmpaddingChart">
                          {this.state.value !== undefined &&
                          (isEmptyChart(
                            this.state.value?.resourceDashboardMap?.ASP
                              ?.costGraph?.costGraphList
                          ) ||
                            !this.state.isPdfClick) ? (
                            <>
                              <div
                                style={{
                                  color: "#393939",
                                  fontWeight: "500",
                                  fontSize:
                                    window.innerWidth >= 1530
                                      ? "20px"
                                      : window.innerWidth >= 1400
                                      ? "18px"
                                      : window.innerWidth >= 1250
                                      ? "16px"
                                      : "15px",
                                  fontFamily: "Poppins, sans-serif",
                                  whiteSpace: "normal",
                                  textAlign: "center",
                                  minHeight: "60px",
                                  alignContent: "center",
                                }}
                              >
                                Aggregate ASP Monthly Cost Run-Rate Saving By
                                Rightsizing
                              </div>
                              <ChartComponent
                                ref={(chart) => (this.aspCostChart = chart)}
                                id="aspcost"
                                primaryXAxis={this.state.costxAxis}
                                pointRender={this.axisPointRender}
                                axisLabelRender={this.axisLabelRender}
                                primaryYAxis={this.state.costyAxisAsp}
                                title=""
                                titleStyle={this.state.chartTitleStyle}
                                palettes={this.state.costPerfPalette}
                                legendSettings={this.state.legendSettings}
                                width={this.state.chartWidth}
                                height={this.state.chartHeight}
                              >
                                <Inject
                                  services={[
                                    ColumnSeries,
                                    Legend,
                                    DataLabel,
                                    Category,
                                  ]}
                                />
                                <SeriesCollectionDirective>
                                  <SeriesDirective
                                    dataSource={aspCostGraphList}
                                    xName="type"
                                    yName="currentPrice"
                                    name="Current"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  {this.state.value?.resourceDashboardMap?.ASP
                                    ?.costGraph?.costGraphList.length > 0 &&
                                  parseFloat(
                                    this.state.value?.resourceDashboardMap?.ASP
                                      ?.costGraph?.costGraphList[0]
                                      .selectedPrice
                                  ) > 0 ? (
                                    <SeriesDirective
                                      dataSource={aspCostGraphList}
                                      xName="type"
                                      yName="selectedPrice"
                                      name="Lowest"
                                      type="Column"
                                      legendShape="Rectangle"
                                      marker={this.state.costPerfMarker}
                                      columnSpacing="0.1"
                                      columnWidth="1"
                                    ></SeriesDirective>
                                  ) : null}
                                  <SeriesDirective
                                    dataSource={aspCostGraphList}
                                    xName="type"
                                    yName="aggressivePrice"
                                    name="Economical"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  <SeriesDirective
                                    dataSource={aspCostGraphList}
                                    xName="type"
                                    yName="balancedPrice"
                                    name="Balanced"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  <SeriesDirective
                                    dataSource={aspCostGraphList}
                                    xName="type"
                                    yName="conservativePrice"
                                    name="Enhanced"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                </SeriesCollectionDirective>
                              </ChartComponent>
                            </>
                          ) : null}
                        </Col>
                        <Col
                          sm="12"
                          className="rmpaddingChart"
                          style={{ marginTop: "20px" }}
                        >
                          {this.state.value !== undefined &&
                          (isEmptyChart(
                            this.state.value?.resourceDashboardMap?.ASP
                              ?.perfGraph?.perfDTOList
                          ) ||
                            !this.state.isPdfClick) ? (
                            <>
                              {" "}
                              <div
                                style={{
                                  color: "#393939",
                                  fontWeight: "500",
                                  fontSize:
                                    window.innerWidth >= 1530
                                      ? "20px"
                                      : window.innerWidth >= 1400
                                      ? "18px"
                                      : window.innerWidth >= 1250
                                      ? "16px"
                                      : "15px",
                                  fontFamily: "Poppins, sans-serif",
                                  whiteSpace: "normal",
                                  textAlign: "center",
                                  minHeight: "60px",
                                  alignContent: "center",
                                }}
                              >
                                Average ASP Relative Performance By Rightsizing
                              </div>
                              <ChartComponent
                                ref={(chart) => (this.aspPerfChart = chart)}
                                id="aspperf"
                                primaryXAxis={this.state.perfxAxis}
                                pointRender={this.axisPointRender}
                                axisLabelRender={this.axisLabelRender}
                                primaryYAxis={this.state.perfyAxisAsp}
                                title=""
                                titleStyle={this.state.chartTitleStyle}
                                palettes={this.state.costPerfPalette}
                                legendSettings={this.state.legendSettings}
                                // height="500"
                                width={this.state.chartWidth}
                                height={this.state.chartHeight}
                              >
                                <Inject
                                  services={[
                                    ColumnSeries,
                                    Legend,
                                    DataLabel,
                                    Category,
                                  ]}
                                />
                                <SeriesCollectionDirective>
                                  <SeriesDirective
                                    dataSource={aspPerGraphList}
                                    xName="type"
                                    yName="currentPerf"
                                    name="Current"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  {this.state.value?.resourceDashboardMap?.ASP
                                    ?.perfGraph?.perfDTOList.length > 0 &&
                                  parseFloat(
                                    this.state.value?.resourceDashboardMap?.ASP
                                      ?.perfGraph?.perfDTOList[0].resizedPerf
                                  ) > 0 ? (
                                    <SeriesDirective
                                      dataSource={aspPerGraphList}
                                      xName="type"
                                      yName="resizedPerf"
                                      name="Optimally Sized"
                                      type="Column"
                                      legendShape="Rectangle"
                                      marker={this.state.costPerfMarker}
                                      columnSpacing="0.1"
                                      columnWidth="1"
                                    ></SeriesDirective>
                                  ) : null}
                                  <SeriesDirective
                                    dataSource={aspPerGraphList}
                                    xName="type"
                                    yName="aggressivePerf"
                                    name="Economical"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  <SeriesDirective
                                    dataSource={aspPerGraphList}
                                    xName="type"
                                    yName="balancedPerf"
                                    name="Balanced"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  <SeriesDirective
                                    dataSource={aspPerGraphList}
                                    xName="type"
                                    yName="conservativePerf"
                                    name="Enhanced"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                </SeriesCollectionDirective>
                              </ChartComponent>
                            </>
                          ) : null}
                        </Col>
                        <Col
                          sm="12"
                          className="rmpaddingChart"
                          style={{ textAlign: "center", marginTop: "20px" }}
                        >
                          {this.state.value !== undefined &&
                          (isEmptyChart(
                            this.state.value?.resourceDashboardMap?.ASP
                              ?.pieChartList
                          ) ||
                            !this.state.isPdfClick) ? (
                            this.state.value?.resourceDashboardMap?.ASP
                              ?.pieChartList &&
                            this.state.value?.resourceDashboardMap?.ASP
                              ?.pieChartList.length > 0 ? (
                              <>
                                <div className="d-block d-md-none chart-title-mobile ">
                                  Progress
                                </div>
                                <AccumulationChartComponent
                                  ref={(chart) => (this.aspProgressPie = chart)}
                                  id="aspprogressPie"
                                  title="Progress"
                                  height="350"
                                  // width="565"
                                  titleStyle={this.state.chartTitleStyle}
                                  enableSmartLabels="true"
                                  textRender={this.textRender}
                                  legendSettings={
                                    this.state.pieLegendSettingsAll
                                  }
                                  legendRender={this.legendRenderAsp}
                                >
                                  <Inject
                                    services={[
                                      AccumulationDataLabel,
                                      AccumulationLegend,
                                    ]}
                                  />
                                  <AccumulationSeriesCollectionDirective>
                                    <AccumulationSeriesDirective
                                      dataSource={
                                        this.state.value !== undefined &&
                                        this.state.value
                                          .resourceDashboardMap !== undefined &&
                                        this.state.value.resourceDashboardMap
                                          .ASP !== undefined
                                          ? this.state.value
                                              .resourceDashboardMap.ASP
                                              .pieChartList
                                          : []
                                      }
                                      xName="x"
                                      yName="y"
                                      pointColorMapping="fill"
                                      dataLabel={this.state.datalabel}
                                      legendShape="Rectangle"
                                    ></AccumulationSeriesDirective>
                                  </AccumulationSeriesCollectionDirective>
                                </AccumulationChartComponent>
                              </>
                            ) : (
                              <div className="dashboardPieChartEmpty">
                                <div className="emptyDivChartTitle">
                                  Progress
                                </div>
                                <h6>
                                  No ASPs Qualify For Rightsizing Analysis
                                </h6>
                              </div>
                            )
                          ) : null}
                        </Col>
                      </Row>
                    </TabPane>
                  ) : null}
                  {this.state.isRenderDBs ? (
                    <TabPane tabId="3" id="dbChartsTab">
                      <Row
                        className="rmpaddingChart"
                        style={{ textAlign: "center" }}
                        id="dbCharts"
                      >
                        <Col sm="12" className="rmpaddingChart">
                          {this.state.value !== undefined &&
                          (isEmptyChart(
                            this.state.value?.resourceDashboardMap?.DB
                              ?.costGraph?.costGraphList
                          ) ||
                            !this.state.isPdfClick) ? (
                            <>
                              <div
                                style={{
                                  color: "#393939",
                                  fontWeight: "500",
                                  fontSize:
                                    window.innerWidth >= 1530
                                      ? "20px"
                                      : window.innerWidth >= 1400
                                      ? "18px"
                                      : window.innerWidth >= 1250
                                      ? "16px"
                                      : "15px",
                                  fontFamily: "Poppins, sans-serif",
                                  whiteSpace: "normal",
                                  textAlign: "center",
                                  minHeight: "60px",
                                  alignContent: "center",
                                }}
                              >
                                Aggregate DBaaS Monthly Cost Run-Rate Saving By
                                Rightsizing
                              </div>
                              <ChartComponent
                                ref={(chart) => (this.dbCostChart = chart)}
                                id="dbcost"
                                primaryXAxis={this.state.costxAxis}
                                pointRender={this.axisPointRender}
                                axisLabelRender={this.axisLabelRender}
                                primaryYAxis={this.state.costyAxisDb}
                                title=""
                                titleStyle={this.state.chartTitleStyle}
                                palettes={this.state.costPerfPalette}
                                legendSettings={this.state.legendSettings}
                                // height="500"
                                width={this.state.chartWidth}
                                height={this.state.chartHeight}
                              >
                                <Inject
                                  services={[
                                    ColumnSeries,
                                    Legend,
                                    DataLabel,
                                    Category,
                                  ]}
                                />
                                <SeriesCollectionDirective>
                                  <SeriesDirective
                                    dataSource={dbCostGraphList}
                                    xName="type"
                                    yName="currentPrice"
                                    name="Current"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  {this.state.value?.resourceDashboardMap?.DB
                                    ?.costGraph?.costGraphList.length > 0 &&
                                  parseFloat(
                                    this.state.value?.resourceDashboardMap?.DB
                                      ?.costGraph?.costGraphList[0]
                                      .selectedPrice
                                  ) > 0 ? (
                                    <SeriesDirective
                                      dataSource={dbCostGraphList}
                                      xName="type"
                                      yName="selectedPrice"
                                      name="Optimally Sized"
                                      type="Column"
                                      legendShape="Rectangle"
                                      marker={this.state.costPerfMarker}
                                      columnSpacing="0.1"
                                      columnWidth="1"
                                    ></SeriesDirective>
                                  ) : null}
                                  <SeriesDirective
                                    dataSource={dbCostGraphList}
                                    xName="type"
                                    yName="aggressivePrice"
                                    name="Economical"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  <SeriesDirective
                                    dataSource={dbCostGraphList}
                                    xName="type"
                                    yName="balancedPrice"
                                    name="Balanced"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  <SeriesDirective
                                    dataSource={dbCostGraphList}
                                    xName="type"
                                    yName="conservativePrice"
                                    name="Enhanced"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                </SeriesCollectionDirective>
                              </ChartComponent>
                            </>
                          ) : null}
                        </Col>
                        <Col
                          sm="12"
                          className="rmpaddingChart"
                          style={{ marginTop: "20px" }}
                        >
                          {this.state.value !== undefined &&
                          (isEmptyChart(
                            this.state.value?.resourceDashboardMap?.DB
                              ?.perfGraph?.perfDTOList
                          ) ||
                            !this.state.isPdfClick) ? (
                            <>
                              {" "}
                              <div
                                style={{
                                  color: "#393939",
                                  fontWeight: "500",
                                  fontSize:
                                    window.innerWidth >= 1530
                                      ? "20px"
                                      : window.innerWidth >= 1400
                                      ? "18px"
                                      : window.innerWidth >= 1250
                                      ? "16px"
                                      : "15px",
                                  fontFamily: "Poppins, sans-serif",
                                  whiteSpace: "normal",
                                  textAlign: "center",
                                  minHeight: "60px",
                                  alignContent: "center",
                                }}
                              >
                                Average DBaaS Relative Performance By
                                Rightsizing
                              </div>
                              <ChartComponent
                                ref={(chart) => (this.dbPerfChart = chart)}
                                id="dbperf"
                                primaryXAxis={this.state.perfxAxis}
                                pointRender={this.axisPointRender}
                                axisLabelRender={this.axisLabelRender}
                                primaryYAxis={this.state.perfyAxisDb}
                                title=""
                                titleStyle={this.state.chartTitleStyle}
                                palettes={this.state.costPerfPalette}
                                legendSettings={this.state.legendSettings}
                                // height="500"
                                width={this.state.chartWidth}
                                height={this.state.chartHeight}
                              >
                                <Inject
                                  services={[
                                    ColumnSeries,
                                    Legend,
                                    DataLabel,
                                    Category,
                                  ]}
                                />
                                <SeriesCollectionDirective>
                                  <SeriesDirective
                                    dataSource={dbPerGraphList}
                                    xName="type"
                                    yName="currentPerf"
                                    name="Current"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  {this.state.value?.resourceDashboardMap?.DB
                                    ?.perfGraph?.perfDTOList.length > 0 &&
                                  parseFloat(
                                    this.state.value?.resourceDashboardMap?.DB
                                      ?.perfGraph?.perfDTOList[0].resizedPerf
                                  ) > 0 ? (
                                    <SeriesDirective
                                      dataSource={dbPerGraphList}
                                      xName="type"
                                      yName="resizedPerf"
                                      name="Optimally Sized"
                                      type="Column"
                                      legendShape="Rectangle"
                                      marker={this.state.costPerfMarker}
                                      columnSpacing="0.1"
                                      columnWidth="1"
                                    ></SeriesDirective>
                                  ) : null}
                                  <SeriesDirective
                                    dataSource={dbPerGraphList}
                                    xName="type"
                                    yName="aggressivePerf"
                                    name="Economical"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  <SeriesDirective
                                    dataSource={dbPerGraphList}
                                    xName="type"
                                    yName="balancedPerf"
                                    name="Balanced"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  <SeriesDirective
                                    dataSource={dbPerGraphList}
                                    xName="type"
                                    yName="conservativePerf"
                                    name="Enhanced"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                </SeriesCollectionDirective>
                              </ChartComponent>
                            </>
                          ) : null}
                        </Col>
                        <Col
                          sm="12"
                          className="rmpaddingChart"
                          style={{ textAlign: "center", marginTop: "20px" }}
                        >
                          {this.state.value !== undefined &&
                          (isEmptyChart(
                            this.state.value?.resourceDashboardMap?.DB
                              ?.pieChartList
                          ) ||
                            !this.state.isPdfClick) ? (
                            this.state.value?.resourceDashboardMap?.DB
                              ?.pieChartList &&
                            this.state.value?.resourceDashboardMap?.DB
                              ?.pieChartList.length > 0 ? (
                              <>
                                <div className="d-block d-md-none chart-title-mobile ">
                                  Progress
                                </div>

                                <AccumulationChartComponent
                                  ref={(chart) => (this.dbProgressPie = chart)}
                                  id="dbprogressPie"
                                  title="Progress"
                                  height="350"
                                  // width="565"
                                  titleStyle={this.state.chartTitleStyle}
                                  enableSmartLabels="true"
                                  textRender={this.textRender}
                                  legendSettings={
                                    this.state.pieLegendSettingsAll
                                  }
                                  legendRender={this.legendRenderDb}
                                >
                                  <Inject
                                    services={[
                                      AccumulationDataLabel,
                                      AccumulationLegend,
                                    ]}
                                  />

                                  <AccumulationSeriesCollectionDirective>
                                    <AccumulationSeriesDirective
                                      dataSource={
                                        this.state.value !== undefined &&
                                        this.state.value
                                          .resourceDashboardMap !== undefined &&
                                        this.state.value.resourceDashboardMap
                                          .DB !== undefined
                                          ? this.state.value
                                              .resourceDashboardMap.DB
                                              .pieChartList
                                          : []
                                      }
                                      xName="x"
                                      yName="y"
                                      pointColorMapping="fill"
                                      dataLabel={this.state.datalabel}
                                      legendShape="Rectangle"
                                    ></AccumulationSeriesDirective>
                                  </AccumulationSeriesCollectionDirective>
                                </AccumulationChartComponent>
                              </>
                            ) : (
                              <div className="dashboardPieChartEmpty">
                                <div className="emptyDivChartTitle">
                                  Progress
                                </div>
                                <h6>
                                  No DBaaS Qualify For Rightsizing Analysis
                                </h6>
                              </div>
                            )
                          ) : null}
                        </Col>
                      </Row>
                    </TabPane>
                  ) : null}
                </TabContent>
              </Col>
              <Col
                sm="6"
                style={{
                  paddingRight: window.innerWidth < 767 ? 0 : "15px",
                  paddingLeft: window.innerWidth < 767 ? 0 : "15px",
                }}
              >
                <Nav tabs className="navClass" id="dashtabs">
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: this.state.activeFuncTab === "1",
                      })}
                      onClick={() => {
                        this.toggleFunc("1");
                      }}
                    >
                      Rightsizing
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: this.state.activeFuncTab === "2",
                      })}
                      onClick={() => {
                        this.toggleFunc("2");
                      }}
                    >
                      Parking
                    </NavLink>
                  </NavItem>
                  {this.state.isRenderCleanup ? (
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeFuncTab === "3",
                        })}
                        onClick={() => {
                          this.toggleFunc("3");
                        }}
                      >
                        Cleanup
                      </NavLink>
                    </NavItem>
                  ) : null}
                </Nav>
                <TabContent
                  id="dashtabcontent"
                  activeTab={this.state.activeFuncTab}
                >
                  <TabPane tabId="1" id="rightsizingChartsTab">
                    <Row
                      className="rmpaddingChart"
                      style={{ textAlign: "center" }}
                      id="rightsizingCharts"
                    >
                      <Col xs="12" sm="12" className="rmpaddingChart">
                        {this.state.value !== undefined &&
                        (isEmptyChart(
                          this.state.value?.functionDashboardMap?.RIGHTSIZE
                            ?.costGraph?.costGraphList
                        ) ||
                          !this.state.isPdfClick) ? (
                          <>
                            <div
                              style={{
                                color: "#393939",
                                fontWeight: "500",
                                fontSize:
                                  window.innerWidth >= 1530
                                    ? "20px"
                                    : window.innerWidth >= 1400
                                    ? "18px"
                                    : window.innerWidth >= 1250
                                    ? "16px"
                                    : "15px",
                                fontFamily: "Poppins, sans-serif",
                                whiteSpace: "normal",
                                textAlign: "center",
                                minHeight: "60px",
                                alignContent: "center",
                              }}
                            >
                              Aggregate Cost Run-Rate Saving
                            </div>
                            <ChartComponent
                              ref={(chart) => (this.rightCostChart = chart)}
                              id="rightcost"
                              primaryXAxis={this.state.costxAxis}
                              axisLabelRender={this.axisLabelRender}
                              primaryYAxis={this.state.costyAxisRight}
                              title=""
                              titleStyle={this.state.chartTitleStyle}
                              palettes={this.state.costPerfPalette}
                              legendSettings={this.state.legendSettings}
                              // height="500"
                              width={this.state.chartWidth}
                              height={this.state.chartHeight}
                            >
                              <Inject
                                services={[
                                  ColumnSeries,
                                  Legend,
                                  DataLabel,
                                  Category,
                                ]}
                              />
                              <SeriesCollectionDirective>
                                <SeriesDirective
                                  dataSource={rightsizeCostGraphList}
                                  xName="type"
                                  yName="currentPrice"
                                  name="Current"
                                  type="Column"
                                  legendShape="Rectangle"
                                  marker={this.state.costPerfMarker}
                                  columnSpacing="0.1"
                                  columnWidth="1"
                                ></SeriesDirective>
                                {this.state.value?.functionDashboardMap
                                  ?.RIGHTSIZE?.costGraph?.costGraphList.length >
                                  0 &&
                                parseFloat(
                                  this.state.value?.functionDashboardMap
                                    ?.RIGHTSIZE?.costGraph?.costGraphList[0]
                                    .selectedPrice
                                ) > 0 ? (
                                  <SeriesDirective
                                    dataSource={rightsizeCostGraphList}
                                    xName="type"
                                    yName="selectedPrice"
                                    name="Optimally Sized"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                ) : null}
                                <SeriesDirective
                                  dataSource={rightsizeCostGraphList}
                                  xName="type"
                                  yName="aggressivePrice"
                                  name="Economical"
                                  type="Column"
                                  legendShape="Rectangle"
                                  marker={this.state.costPerfMarker}
                                  columnSpacing="0.1"
                                  columnWidth="1"
                                ></SeriesDirective>
                                <SeriesDirective
                                  dataSource={rightsizeCostGraphList}
                                  xName="type"
                                  yName="balancedPrice"
                                  name="Balanced"
                                  type="Column"
                                  legendShape="Rectangle"
                                  marker={this.state.costPerfMarker}
                                  columnSpacing="0.1"
                                  columnWidth="1"
                                ></SeriesDirective>
                                <SeriesDirective
                                  dataSource={rightsizeCostGraphList}
                                  xName="type"
                                  yName="conservativePrice"
                                  name="Enhanced"
                                  type="Column"
                                  legendShape="Rectangle"
                                  marker={this.state.costPerfMarker}
                                  columnSpacing="0.1"
                                  columnWidth="1"
                                ></SeriesDirective>
                              </SeriesCollectionDirective>
                            </ChartComponent>
                          </>
                        ) : null}
                      </Col>
                      <Col
                        xs="12"
                        sm="12"
                        className="rmpaddingChart"
                        style={{ marginTop: "20px" }}
                      >
                        {this.state.value !== undefined &&
                        (isEmptyChart(
                          this.state.value?.functionDashboardMap?.RIGHTSIZE
                            ?.perfGraph?.perfDTOList
                        ) ||
                          !this.state.isPdfClick) ? (
                          <>
                            <div
                              style={{
                                color: "#393939",
                                fontWeight: "500",
                                fontSize:
                                  window.innerWidth >= 1530
                                    ? "20px"
                                    : window.innerWidth >= 1400
                                    ? "18px"
                                    : window.innerWidth >= 1250
                                    ? "16px"
                                    : "15px",
                                fontFamily: "Poppins, sans-serif",
                                whiteSpace: "normal",
                                textAlign: "center",
                                minHeight: "60px",
                                alignContent: "center",
                              }}
                            >
                              Average Relative Performance
                            </div>

                            <ChartComponent
                              ref={(chart) => (this.rightperfChart = chart)}
                              id="rightperf"
                              primaryXAxis={this.state.perfxAxis}
                              pointRender={this.axisPointRender}
                              axisLabelRender={this.axisLabelRender}
                              primaryYAxis={this.state.perfyAxisRight}
                              title=""
                              titleStyle={this.state.chartTitleStyle}
                              palettes={this.state.costPerfPalette}
                              legendSettings={this.state.legendSettings}
                              // height="500"
                              width={this.state.chartWidth}
                              height={this.state.chartHeight}
                            >
                              <Inject
                                services={[
                                  ColumnSeries,
                                  Legend,
                                  DataLabel,
                                  Category,
                                ]}
                              />
                              <SeriesCollectionDirective>
                                <SeriesDirective
                                  dataSource={rightsizePerfDTOList}
                                  xName="type"
                                  yName="currentPerf"
                                  name="Current"
                                  type="Column"
                                  legendShape="Rectangle"
                                  marker={this.state.costPerfMarker}
                                  columnSpacing="0.1"
                                  columnWidth="1"
                                ></SeriesDirective>
                                {this.state.value?.functionDashboardMap
                                  ?.RIGHTSIZE?.perfGraph?.perfDTOList.length >
                                  0 &&
                                parseFloat(
                                  this.state.value?.functionDashboardMap
                                    ?.RIGHTSIZE?.perfGraph?.perfDTOList[0]
                                    .resizedPerf
                                ) > 0 ? (
                                  <SeriesDirective
                                    dataSource={rightsizePerfDTOList}
                                    xName="type"
                                    yName="resizedPerf"
                                    name="Optimally Sized"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                ) : null}
                                <SeriesDirective
                                  dataSource={rightsizePerfDTOList}
                                  xName="type"
                                  yName="aggressivePerf"
                                  name="Economical"
                                  type="Column"
                                  legendShape="Rectangle"
                                  marker={this.state.costPerfMarker}
                                  columnSpacing="0.1"
                                  columnWidth="1"
                                ></SeriesDirective>
                                <SeriesDirective
                                  dataSource={rightsizePerfDTOList}
                                  xName="type"
                                  yName="balancedPerf"
                                  name="Balanced"
                                  type="Column"
                                  legendShape="Rectangle"
                                  marker={this.state.costPerfMarker}
                                  columnSpacing="0.1"
                                  columnWidth="1"
                                ></SeriesDirective>
                                <SeriesDirective
                                  dataSource={rightsizePerfDTOList}
                                  xName="type"
                                  yName="conservativePerf"
                                  name="Enhanced"
                                  type="Column"
                                  legendShape="Rectangle"
                                  marker={this.state.costPerfMarker}
                                  columnSpacing="0.1"
                                  columnWidth="1"
                                ></SeriesDirective>
                              </SeriesCollectionDirective>
                            </ChartComponent>
                          </>
                        ) : null}
                      </Col>
                      <Col
                        xs="12"
                        sm="12"
                        className="rmpaddingChart"
                        style={{ textAlign: "center", marginTop: "20px" }}
                      >
                        {this.state.value !== undefined &&
                        (isEmptyChart(
                          this.state.value?.functionDashboardMap?.RIGHTSIZE
                            ?.pieChartList
                        ) ||
                          !this.state.isPdfClick) ? (
                          this.state.value?.functionDashboardMap?.RIGHTSIZE
                            ?.pieChartList &&
                          this.state.value?.functionDashboardMap?.RIGHTSIZE
                            ?.pieChartList.length > 0 ? (
                            <>
                              <div className="d-block d-md-none chart-title-mobile ">
                                Progress
                              </div>

                              <AccumulationChartComponent
                                ref={(chart) => (this.rightProgressPie = chart)}
                                id="rightprogressPie"
                                title="Progress"
                                height="350"
                                // width="565"
                                titleStyle={this.state.chartTitleStyle}
                                enableSmartLabels="true"
                                textRender={this.textRender}
                                legendSettings={this.state.pieLegendSettingsAll}
                                legendRender={this.legendRenderRight}
                              >
                                <Inject
                                  services={[
                                    AccumulationDataLabel,
                                    AccumulationLegend,
                                  ]}
                                />
                                <AccumulationSeriesCollectionDirective>
                                  <AccumulationSeriesDirective
                                    dataSource={
                                      this.state.value !== undefined &&
                                      this.state.value.functionDashboardMap !==
                                        undefined &&
                                      this.state.value.functionDashboardMap
                                        .RIGHTSIZE !== undefined
                                        ? this.state.value?.functionDashboardMap
                                            ?.RIGHTSIZE.pieChartList
                                        : []
                                    }
                                    xName="x"
                                    yName="y"
                                    pointColorMapping="fill"
                                    dataLabel={this.state.datalabel}
                                    legendShape="Rectangle"
                                  ></AccumulationSeriesDirective>
                                </AccumulationSeriesCollectionDirective>
                              </AccumulationChartComponent>
                            </>
                          ) : (
                            <div className="dashboardPieChartEmpty">
                              <div className="emptyDivChartTitle">Progress</div>
                              <h6>No VMs Qualify For Rightsizing Analysis</h6>
                            </div>
                          )
                        ) : null}
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="2" id="parkingChartsTab">
                    <Row
                      className="rmpaddingChart"
                      style={{ textAlign: "center" }}
                      id="parkingCharts"
                    >
                      <Col xs="12" sm="12" className="rmpaddingChart">
                        {this.state.value !== undefined &&
                        (isEmptyChart(
                          this.state.value?.functionDashboardMap?.VM_PARKING
                            ?.costGraph?.costGraphList
                        ) ||
                          !this.state.isPdfClick) ? (
                          <>
                            <div
                              style={{
                                color: "#393939",
                                fontWeight: "500",
                                fontSize:
                                  window.innerWidth >= 1530
                                    ? "20px"
                                    : window.innerWidth >= 1400
                                    ? "18px"
                                    : window.innerWidth >= 1250
                                    ? "16px"
                                    : "15px",
                                fontFamily: "Poppins, sans-serif",
                                whiteSpace: "normal",
                                textAlign: "center",
                                minHeight: "60px",
                                alignContent: "center",
                              }}
                            >
                              Aggregate Cost Run-Rate Saving
                            </div>

                            <ChartComponent
                              enableAnimation={window.innerWidth >= 767}
                              ref={(chart) => (this.parkCostChart = chart)}
                              id="parkcost"
                              primaryXAxis={this.state.costxAxis}
                              pointRender={this.axisPointRender}
                              axisLabelRender={this.axisLabelRender}
                              primaryYAxis={this.state.costyAxisParking}
                              title=""
                              titleStyle={this.state.chartTitleStyle}
                              palettes={this.state.costPerfPalette}
                              legendSettings={this.state.legendSettings}
                              // height="500"
                              width={this.state.chartWidth}
                              height={this.state.chartHeight}
                            >
                              <Inject
                                services={[
                                  ColumnSeries,
                                  Legend,
                                  DataLabel,
                                  Category,
                                ]}
                              />
                              <SeriesCollectionDirective>
                                <SeriesDirective
                                  dataSource={parkingCostGraphList}
                                  xName="type"
                                  yName="currentPrice"
                                  name="Current"
                                  type="Column"
                                  legendShape="Rectangle"
                                  marker={this.state.costPerfMarker}
                                  columnSpacing="0.1"
                                  columnWidth="1"
                                ></SeriesDirective>
                                <SeriesDirective
                                  dataSource={parkingCostGraphList}
                                  xName="type"
                                  yName="aggressivePrice"
                                  name="Lowest"
                                  type="Column"
                                  legendShape="Rectangle"
                                  marker={this.state.costPerfMarker}
                                  columnSpacing="0.1"
                                  columnWidth="1"
                                ></SeriesDirective>
                                {/*<SeriesDirective dataSource={this.state.value !== undefined ? this.state.value?.functionDashboardMap??.VM_PARKING.costGraph.costGraphList : []} xName='type' yName='selectedPrice' name='Optimally Parked' type='Column' legendShape='Rectangle' marker={this.state.costPerfMarker} >
                                         </SeriesDirective>*/}
                              </SeriesCollectionDirective>
                            </ChartComponent>
                          </>
                        ) : null}
                      </Col>
                      <Col
                        xs="12"
                        sm="12"
                        className="rmpaddingChart"
                        style={{ textAlign: "center", marginTop: "20px" }}
                      >
                        {this.state.value !== undefined &&
                        (isEmptyChart(
                          this.state.value?.functionDashboardMap?.VM_PARKING
                            ?.pieChartList
                        ) ||
                          !this.state.isPdfClick) ? (
                          this.state.value?.functionDashboardMap?.VM_PARKING
                            ?.pieChartList &&
                          this.state.value?.functionDashboardMap?.VM_PARKING
                            ?.pieChartList.length > 0 ? (
                            <>
                              {" "}
                              <div className="d-block d-md-none chart-title-mobile ">
                                Progress
                              </div>
                              <AccumulationChartComponent
                                ref={(chart) => (this.parkProgressPie = chart)}
                                id="parkprogressPie"
                                title="Progress"
                                height="350"
                                // width="565"
                                titleStyle={this.state.chartTitleStyle}
                                enableSmartLabels="true"
                                textRender={this.textRender}
                                legendSettings={this.state.pieLegendSettingsAll}
                                legendRender={this.legendRenderParking}
                              >
                                <Inject
                                  services={[
                                    AccumulationDataLabel,
                                    AccumulationLegend,
                                  ]}
                                />

                                <AccumulationSeriesCollectionDirective>
                                  <AccumulationSeriesDirective
                                    dataSource={
                                      this.state.value !== undefined &&
                                      this.state.value.functionDashboardMap !==
                                        undefined &&
                                      this.state.value.functionDashboardMap
                                        .VM_PARKING !== undefined
                                        ? this.state.value?.functionDashboardMap
                                            .VM_PARKING.pieChartList
                                        : []
                                    }
                                    xName="x"
                                    yName="y"
                                    pointColorMapping="fill"
                                    dataLabel={this.state.datalabel}
                                    legendShape="Rectangle"
                                  ></AccumulationSeriesDirective>
                                </AccumulationSeriesCollectionDirective>
                              </AccumulationChartComponent>
                            </>
                          ) : (
                            <div className="dashboardPieChartEmpty">
                              <div className="emptyDivChartTitle">Progress</div>
                              <h6>No VMs Qualify For Parking Analysis</h6>
                            </div>
                          )
                        ) : null}
                      </Col>
                    </Row>
                  </TabPane>
                  {this.state.isRenderCleanup ? (
                    <TabPane tabId="3" id="cleanupChartsTab">
                      <Row
                        className="rmpaddingChart"
                        style={{ textAlign: "center" }}
                        id="cleanupCharts"
                      >
                        <Col xs="12" sm="12" className="rmpaddingChart">
                          {this.state.value !== undefined &&
                          (isEmptyChart(
                            this.state.value?.functionDashboardMap?.CLEANUP
                              ?.costGraph?.costGraphList
                          ) ||
                            !this.state.isPdfClick) ? (
                            <>
                              <div
                                style={{
                                  color: "#393939",
                                  fontWeight: "500",
                                  fontSize:
                                    window.innerWidth >= 1530
                                      ? "20px"
                                      : window.innerWidth >= 1400
                                      ? "18px"
                                      : window.innerWidth >= 1250
                                      ? "16px"
                                      : "15px",
                                  fontFamily: "Poppins, sans-serif",
                                  whiteSpace: "normal",
                                  textAlign: "center",
                                  minHeight: "60px",
                                  alignContent: "center",
                                }}
                              >
                                Aggregate Cost Run-Rate Saving by Metric Data
                                Source Cleanup
                              </div>

                              <ChartComponent
                                ref={(chart) => (this.cleanupCostChart = chart)}
                                id="cleanupcost"
                                primaryXAxis={this.state.costxAxis}
                                pointRender={this.axisPointRender}
                                axisLabelRender={this.axisLabelRender}
                                primaryYAxis={this.state.costyAxisCleanup}
                                title=""
                                titleStyle={this.state.chartTitleStyle}
                                palettes={this.state.costPerfPalette}
                                legendSettings={this.state.legendSettings}
                                // height="500"
                                width={this.state.chartWidth}
                                height={this.state.chartHeight}
                              >
                                <Inject
                                  services={[
                                    ColumnSeries,
                                    Legend,
                                    DataLabel,
                                    Category,
                                  ]}
                                />
                                <SeriesCollectionDirective>
                                  <SeriesDirective
                                    dataSource={cleanupCostGraphList}
                                    xName="type"
                                    yName="currentPrice"
                                    name="Pre-Cleanup"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  <SeriesDirective
                                    dataSource={cleanupCostGraphList}
                                    xName="type"
                                    yName="aggressivePrice"
                                    name="Post-Cleanup"
                                    type="Column"
                                    legendShape="Rectangle"
                                    marker={this.state.costPerfMarker}
                                    columnSpacing="0.1"
                                    columnWidth="1"
                                  ></SeriesDirective>
                                  {/*<SeriesDirective dataSource={this.state.value !== undefined ? this.state.value?.functionDashboardMap.CLEANUP.costGraph.costGraphList : []} xName='type' yName='selectedPrice' name='Optimally Cleaned' type='Column' legendShape='Rectangle' marker={this.state.costPerfMarker} >
                                         </SeriesDirective>*/}
                                </SeriesCollectionDirective>
                              </ChartComponent>
                            </>
                          ) : null}
                        </Col>

                        <Col
                          xs="12"
                          sm="12"
                          className="rmpaddingChart"
                          style={{ textAlign: "center", marginTop: "20px" }}
                        >
                          {this.state.value !== undefined &&
                          (isEmptyChart(
                            this.state.value?.functionDashboardMap?.CLEANUP
                              ?.pieChartList
                          ) ||
                            !this.state.isPdfClick) ? (
                            this.state.value?.functionDashboardMap?.CLEANUP
                              ?.pieChartList &&
                            this.state.value?.functionDashboardMap?.CLEANUP
                              ?.pieChartList.length > 0 ? (
                              <>
                                <div className="d-block d-md-none chart-title-mobile ">
                                  Progress
                                </div>
                                <AccumulationChartComponent
                                  ref={(chart) =>
                                    (this.cleanupProgressPie = chart)
                                  }
                                  id="cleanupProgressPie"
                                  title="Progress"
                                  height="350"
                                  // width="565"
                                  titleStyle={this.state.chartTitleStyle}
                                  enableSmartLabels="true"
                                  textRender={this.textRender}
                                  legendSettings={
                                    this.state.pieLegendSettingsAll
                                  }
                                  legendRender={this.legendRenderCleanup}
                                >
                                  <Inject
                                    services={[
                                      AccumulationDataLabel,
                                      AccumulationLegend,
                                    ]}
                                  />
                                  <AccumulationSeriesCollectionDirective>
                                    <AccumulationSeriesDirective
                                      dataSource={
                                        this.state.value !== undefined &&
                                        this.state.value
                                          .functionDashboardMap !== undefined &&
                                        this.state.value.functionDashboardMap
                                          .CLEANUP !== undefined
                                          ? this.state.value
                                              .functionDashboardMap.CLEANUP
                                              .pieChartList
                                          : []
                                      }
                                      xName="x"
                                      yName="y"
                                      pointColorMapping="fill"
                                      dataLabel={this.state.datalabel}
                                      legendShape="Rectangle"
                                    ></AccumulationSeriesDirective>
                                  </AccumulationSeriesCollectionDirective>
                                </AccumulationChartComponent>
                              </>
                            ) : (
                              <div className="dashboardPieChartEmpty">
                                <div className="emptyDivChartTitle">
                                  Progress
                                </div>
                                <h6>
                                  No Metric Data Source Qualify For Cleanup
                                  Analysis
                                </h6>
                              </div>
                            )
                          ) : null}
                        </Col>
                      </Row>
                    </TabPane>
                  ) : null}
                </TabContent>
              </Col>
            </Row>
          </div>
          <a id="pdfid" />
        </div>

        <Modal
          isOpen={this.state.vmsStatusModal}
          toggle={this.toggleVmsStatusModal}
          size="lg"
          backdrop={"static"}
        >
          <ModalHeader
            toggle={this.toggleVmsStatusModal}
            id="modalheader_list"
            cssModule={{ "modal-title": "modalHeader" }}
          >
            <div
              className="modalCompanyName"
              dangerouslySetInnerHTML={{ __html: message.SerraLabsModalHeader }}
            />
            <div className="modalTitle">
              {" "}
              Status as of {getStringDate(new Date())}
            </div>
          </ModalHeader>
          <ModalBody>
            <div>
              <div className="box-titel">
                <ul>
                  {this.state.vmsCurrentStatus &&
                    Object.keys(this.state.vmsCurrentStatus).map((key) => (
                      <li style={{ textAlign: "left" }}>
                        <pre
                          style={{
                            fontSize: "18px",
                            color: this.state.vmsCurrentStatus[key].startsWith(
                              "Data Source Errors"
                            )
                              ? "#B00020"
                              : this.state.vmsCurrentStatus[key].startsWith(
                                  "Data Source Status"
                                )
                              ? "#00A17A"
                              : "black",
                          }}
                        >
                          {this.filterCurrentStatus(
                            this.state.vmsCurrentStatus[key]
                          )}
                        </pre>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </ModalBody>
          <ModalFooter id="knowMoreFooter">
            <Button
              id="confirmbtn_list"
              onClick={(e) => {
                this.setState({ vmsStatusModal: false });
              }}
            >
              OK
            </Button>{" "}
          </ModalFooter>
        </Modal>

        {this.state.errorPopup === true ? (
          <SerraError
            Errordata={this.state.errormessage}
            ErrorPopup={this.state.errorPopup}
            setErrorMethod={this.setErrorPopupState}
            isError={this.state.isErrorHeader}
          ></SerraError>
        ) : (
          ""
        )}
        {this.state.modalLoader === true ? <SerraLoader></SerraLoader> : ""}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onDataSourceRes: (data) => dispatch(setDataSourceRes(data)),
    setDataSourceRefreshStatus: (data) =>
      dispatch(setDataSourceRefreshStatus(data)),
    startRefreshTimer: () => startManualRefreshDs(dispatch),
  };
};

const mapStateToProps = (state) => {
  return {
    dataSourceResponse: state.dataSourceRes.dataSourceResponse,
    companyDetails: state.companyDetails.data,
    dataSourcePayload: state.dataSourcePayload.payload,
    // onClick datasource refresh state
    refreshStatus: state.dataSourcePayload.refreshStatus,
    isRefreshDSAPI: state.dataSourcePayload.isRefreshDSAPI,
    // 5 min datasource refresh state
    isRefreshing: state.datasource.isRefreshing,
    datasourceRefreshStatus: state.datasource.refreshStatus,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Dashboard));
